/* eslint-disable camelcase */
export const es = {
  AdminDashboard: {
    expiringLicenses: {
      popupHeader: "Atención",
      title: "Lista de cuentas cuya licencia expira en %cnt% días",
      understandButton: "Entendido",
    },
    ActivitiesList: {
      labStatus: {
        error: "error",
        success: "ok",
      },
      labels: {
        action: "Acción",
        context: "Descripción",
        date: "Fecha",
        errorMsg: "Descripción del error",
        executor: "Ejecutor",
        status: "Estado",
      },
    },
    Licence: {
      deletePopup: {
        confirmationText: "Sí, quiero eliminar la licencia",
        contentText:
          "Después de eliminar la licencia, no será posible asignar exámenes",
        headerText: "¿Está seguro de que desea eliminar la licencia?",
      },
      labels: {
        expireDate: "Fecha de vencimiento de licencia",
        licenseDate: "Fecha de emisión de licencia",
        methodologyList: "Metodologías disponibles",
        testsList: "Pruebas disponibles",
      },
    },
    PsychLab: {
      anonymizePopup: {
        headerText:
          "¿Está seguro de que desea anonimizar los datos del cliente?",
        contentText:
          "Todos los exámenes y datos de los examinados serán anonimizados y transferidos a la cuenta Psychometric (los exámenes nuevos e incompletos serán eliminados). La operación no se puede deshacer. ¿Desea continuar?",
        confirmationText: "Sí, quiero anonimizar los datos",
      },
      deletePopup: {
        confirmationText: "Sí, quiero eliminar la cuenta del cliente",
        contentText:
          "Después de eliminar la cuenta del cliente, no será posible restaurar los datos",
        headerText: "¿Está seguro de que desea eliminar la cuenta del cliente?",
      },
    },
    PsychLabManagment: {
      PsychLabView: {
        labels: {
          details: "Detalles",
          download: "Descargar",
          edit: "Editar",
          generate: "Generar",
          name: "Nombre de la prueba",
          nameFile: "Nombre del archivo",
          print: "Imprimir",
          result: "Resultado",
          type: "Tipo de documento",
        },
        tabs: {
          activityAction: "nombre de la acción",
          activityContext: "descripción",
          activityDate: "fecha",
          activityExecutor: "ejecutor",
          activityId: "ID",
          activityLogs: "Registro de actividades",
          activityLogsFile: "registro_actividades",
          activityStatus: "estado",
          license: "Licencia",
          psychLabData: "Datos del cliente",
          stats: "Estadísticas",
          theme: "Apariencia",
          parameters: "Parámetros",
          priceList: "Lista de precios",
          users: "Usuarios",
        },
        parameters: {
          header: "Parámetros del cliente",
          noParameters:
            "No hay parámetros disponibles para este cliente. Compruebe si la licencia está activa.",
        },
      },
      breadcrumbs: {
        add: "Agregar cuenta de cliente",
        addLicense: "Agregar licencia",
        addUser: "Agregar cuenta de usuario",
        dashboard: "Panel de usuario",
        edit: "Editar cuenta de cliente",
        editLicense: "Editar licencia",
        editUser: "Editar cuenta de usuario",
        psychLabs: "Registro de clientes",
      },
      header: {
        add: "Agregar cuenta de cliente",
        addLicense: "Agregar licencia",
        addUser: "Agregar cuenta de usuario",
        edit: "Editar cuenta de cliente",
        editLicense: "Editar licencia",
        editUser: "Editar cuenta de usuario",
      },
    },
    PsychologicalLabsList: {
      labStatus: {
        disabled: "inactivo",
        enabled: "activo",
      },
      labels: {
        all: "todos",
        clientId: "ID del cliente",
        createDate: "Fecha de creación",
        details: "Detalles",
        examinationsCnt: "Número de exámenes",
        examineesCnt: "Número de examinados",
        expireDate: "Fecha de vencimiento de la cuenta",
        licenseExpireDate: "Fecha de vencimiento de licencia",
        moreThen: "más que",
        name: "Nombre del cliente",
        of: "de",
        psychCnt: "Número de usuarios",
        status: "Estado",
        systemAccount: "cuenta del sistema",
        taskPerPage: "Filas por página:",
        usersCnt: "Número de usuarios",
      },
      expiryWarningTooltip:
        "La fecha de vencimiento de la licencia o de la cuenta vence en %count% días",
      expiredWarningTooltip:
        "La fecha de vencimiento de la licencia o de la cuenta ya ha pasado",
      inactiveAccountTooltip: "Cuenta inactiva",
    },
    StatsList: {
      statFileName: "estadisticas_examenes.xlsx",
    },
    UsersList: {
      deletePopup: {
        confirmationText: "Sí, quiero eliminar la cuenta de usuario",
        contentText:
          "Después de eliminar la cuenta de usuario, no será posible restaurarla",
        headerText: "¿Está seguro de que desea eliminar la cuenta de usuario?",
      },
      labStatus: {
        adminRole: "administrador",
        disabled: "inactivo",
        enabled: "activo",
        superUserRole: "super administrador",
        userBaseRole: "registrador",
        userRole: "usuario",
      },
      labels: {
        email: "Correo electrónico",
        examinationCnt: "Número de exámenes (todos / asignados / completados)",
        examinationCnt1: "Número de exámenes",
        examinationCnt2: "todos: ",
        examinationCnt3: "asignados: ",
        examinationCnt4: "completados: ",
        examineeCnt: "Número de participantes",
        firstName: "Nombre",
        isActive: "Estado",
        isStaff: "Rol",
        lastName: "Apellido",
      },
      toolTip: {
        move: "mover exámenes y carpetas",
        delete: "eliminar",
        edit: "editar",
      },
    },
    emptyState: {
      header: "Aún no se han agregado cuentas de clientes",
      info: "Para ver la lista de clientes, agregue al menos una cuenta.",
    },
    emptyStateLicense: {
      header: "Aún no se han agregado licencias",
      info: "Para ver la licencia, agréguela.",
    },
    emptyStateUsers: {
      header: "Aún no se han agregado cuentas de usuario",
      info: "Para ver la lista de usuarios, agregue al menos una cuenta de usuario.",
    },
    header: "Registro de clientes",
    showInactiveAccounts: "Mostrar cuentas inactivas",
    kebabMenu: {
      print: "Imprimir contrato",
      profile: "Ir al perfil del examinado",
    },
  },
  AdminSearchEngine: {
    enterFilter:
      "Puede buscar por nombre, ID, dirección, número de identificación fiscal, fecha de creación, fecha de vencimiento de la cuenta del cliente en formato AAAA-MM-DD, nombre, apellido, correo electrónico del usuario, fecha de vencimiento de la licencia en formato AAAA-MM-DD, metodología, prueba.",
    header: "Buscar clientes",
    noResults: "No hay resultados de búsqueda",
    noResultsForFilter:
      "No se encontraron clientes que cumplan con los requisitos introducidos.",
    placeholderDesktop:
      "nombre, ID, dirección, número de identificación fiscal, fecha de creación, fecha de vencimiento de la cuenta del cliente en formato AAAA-MM-DD, nombre, apellido, correo electrónico del usuario, fecha de vencimiento de la licencia, metodología, prueba",
    placeholderMobile: "Buscar",
    searchForExaminees: "Buscar clientes",
  },
  ArchiveExaminationList: {
    emptyState: {
      info: "No hay evaluaciones archivadas asignadas a este participante",
    },
  },
  Backend: {
    Could_not_bind_users_PsychologicalLab_with_the_directory:
      "No se pudo vincular el centro del usuario con el directorio.",
    Could_not_bind_users_PsychologicalLab_with_the_examinee:
      "No se pudo vincular el centro del usuario con el examinado.",
    Directory_has_related_Examinees:
      "No se puede eliminar el Directorio: El directorio tiene examinados relacionados.",
    Directory_with_given_name_already_exists:
      "Ya existe un directorio con ese nombre.",
    Examination_Card_does_not_have_a_defined_NormSet:
      "La Tarjeta de Examen no tiene una norma de examen asignada.",
    Examinee_with_the_given_id_exists_in_this_psychological_lab:
      "Ya existe un examinado con el DNI proporcionado en la base de datos.",
    Generated_ID_conflict: "Error al generar identificador para el examinado.",
    Incorrect_credentials: "Contraseña incorrecta.",
    Invalid_token_Please_regenerate_password_reset_link:
      "Token inválido, por favor genera un nuevo enlace de restablecimiento de contraseña.",
    Legacy_data_instance_not_found: "No se encontraron datos heredados.",
    Legacy_data_validation_failed: "Error en la validación de datos heredados.",
    Ongoing_examination: "No se puede eliminar el Examen. Examen en curso.",
    User_has_related_Examinations_or_Directories:
      "No se puede eliminar el Usuario: El usuario tiene exámenes o carpetas relacionados.",
    The_Examinee_has_related_Examinations:
      "No se puede eliminar el Examinado: El examinado tiene exámenes relacionados.",
    The_new_pin_cannot_be_the_same_as_the_previous_one:
      "El nuevo PIN no puede ser igual al anterior.",
    The_password_cannot_be_the_same_as_the_previous_one:
      "La contraseña no puede ser igual a la anterior.",
    Token_not_recognized: "Token no reconocido.",
    Unable_to_delete_default_directory:
      "No se puede eliminar el Directorio Predeterminado.",
    Unable_to_parse_Examination_Aim:
      "Error en la validación del Objetivo del Examen.",
    Unable_to_parse_Occupational_Medicine_Basic_Info_data:
      "Error en la validación de datos de Medicina Laboral.",
    Unrecognized_email:
      "Dirección de correo electrónico no reconocida o cuenta no activada.",
    Unrecognized_proxy_error_occurred_while_fetching_legacy_data:
      "Error no reconocido al recuperar datos heredados.",
    Unrecognized_token_Please_regenerate_password_reset_link:
      "Token no reconocido, por favor genera un nuevo enlace de restablecimiento de contraseña.",
    User_activation_code_does_not_exist:
      "El código de activación proporcionado no existe.",
    User_activation_code_has_already_been_used:
      "El código de activación ya ha sido utilizado.",
    User_with_given_id_does_not_exist:
      "El usuario con el ID proporcionado no existe.",
    Validation_failed: "La validación de los datos ha fallado.",
  },
  Buttons: {
    accept: "Acepto",
    addDirectory: "Agregar carpeta",
    addExaminee: "Agregar examinado",
    addMobileExaminee: "Agregar",
    addPsychLab: "Agregar cuenta de cliente",
    addPsychLabLic: "Agregar licencia",
    addPsychUser: "Agregar cuenta de usuario",
    addPsychUserMobile: "Agregar usuario",
    addUser: "Agregar cuenta de usuario",
    alreadyAssigned: "Asignado",
    alreadyAssignedExamination: "Examen en curso",
    assign: "Asignar",
    assignExamination: "Asignar examen",
    back: "Volver",
    backToLogin: "Volver a la página de inicio de sesión",
    begin: "Comenzar",
    cancel: "Cancelar",
    change: "Cambiar",
    clear: "Limpiar",
    close: "Cerrar",
    confirm: "Confirmar",
    continue: "Continuar",
    createExamination: "Asignar examen",
    delete: "Eliminar",
    anonymize: "Anonimizar",
    deleteExaminee: "Eliminar examinado",
    deleteExaminees: "Eliminar examinados",
    anonymizePsychLab: "Anonimizar datos",
    deletePsychLab: "Eliminar cuenta de cliente",
    deletePsychLabLic: "Eliminar licencia",
    disable2FA: "Desactivar autenticación de dos factores",
    downloadAll: "Descargar todo",
    edit: "Editar",
    editExaminee: "Editar examinado",
    editPsychLab: "Editar cuenta de cliente",
    editPsychLabLic: "Editar licencia",
    editPsychLabUser: "Editar cuenta de usuario",
    enable2FA: "Activar autenticación de dos factores",
    examinationWithLawBase: "Examen con base legal",
    examinationWithNoLawBase: "Examen sin base legal",
    exit: "Salir",
    exportActivities: "Exportar a archivo XLS",
    exportResults: "Generar exportación",
    generate: "Generar",
    generateAndPrint: "Generar e imprimir",
    go: "Ir",
    goToDashboard: "Ir al panel de usuario",
    importExaminees: "Importar examinados",
    login: "Iniciar sesión",
    loginPsychLab: "Iniciar sesión en cuenta de cliente",
    move: "Mover",
    moveExaminee: "Mover examinado",
    moveExaminees: "Mover examinados",
    examineesIdsList: "Descargar lista de examinados",
    ok: "Aceptar",
    print: "Imprimir",
    printContract: "Imprimir contrato",
    save: "Guardar",
    saveAndInvate: "Guardar e invitar",
    saveAndPrint: "Guardar e imprimir",
    savePassword: "Guardar contraseña",
    savePin: "Guardar PIN",
    saveSettings: "Guardar configuración",
    search: "Buscar",
    sendEmail: "Enviar mensaje",
    sendLink: "Enviar enlace",
    setNewPassword: "Establecer nueva contraseña",
    setPassword: "Establecer contraseña",
    setPin: "Establecer PIN",
    showActivities: "Mostrar",
    skipTests: "Omitir pruebas",
    understood: "Entendido",
    unblockedExam: "Desbloquear exámenes",
    enable2FAIcon: "Activar autenticación de dos factores",
    disable2FAIcon: "Desactivar autenticación de dos factores",
    openFolder: "Abrir",
  },
  Common: {
    deleteExamineePopup: {
      header: "¿Estás seguro que deseas eliminar al examinado?",
      text: "Después de eliminar al examinado, no será posible restaurar los datos",
      confirmationText: "Sí, quiero eliminar al examinado",
    },
    deleteExamineesPopup: {
      header: "¿Estás seguro que deseas eliminar a los examinados seleccionados?",
      text: "Después de eliminar a los examinados, no será posible restaurar los datos",
      confirmationText: "Sí, quiero eliminar a los examinados",
    },
    deleteExamineeWithExamPopup: {
      header:
        "¿Estás seguro que deseas eliminar al examinado junto con sus exámenes?",
      text: "Después de eliminar al examinado junto con sus exámenes, no será posible restaurar los datos",
      confirmationText:
        "Sí, quiero eliminar al examinado junto con sus exámenes",
    },
    deleteExamineesWithExamPopup: {
      header:
        "¿Estás seguro que deseas eliminar a los examinados seleccionados junto con sus exámenes?",
      text: "Después de eliminar a los examinados junto con sus exámenes, no será posible restaurar los datos",
      confirmationText:
        "Sí, quiero eliminar a los examinados junto con sus exámenes",
    },
    logAdminAsUserPopup: {
      header: "Error",
      text: "No se pudo iniciar sesión en la cuenta del cliente",
    },
    menu: {
      breadcrumbsPsychLab: "Registros de clientes",
      contact: "Ayuda",
      dashboard: "Panel de usuario",
      emailSender: "Enviando un mensaje",
      exportResults: "Exportar resultados",
      examineeRegistry: "Registro de examinados",
      folders: "Registros de examinados",
      importExaminees: "Importar examinados",
      logout: "Cerrar sesión",
      psychlabs: "Registros de clientes",
      search: "Buscar",
      settings: "Configuración",
      priceList: "Lista de precios",
      summary: "Registro de examinados",
    },
    seo: {
      addExaminee: "Añadir examinado",
      addPsychLab: "Añadir cuenta de cliente",
      addPsychLabLic: "Añadir licencia",
      dashboard: "Panel de usuario",
      editExaminee: "Editar examinado",
      emailSender: "Enviando un mensaje",
      examinationAssignment: "Asignación de examen con base legal",
      examinationCard: "Tarjeta de Examen",
      exportResults: "Exportar resultados",
      folders: "Archivo de examinados",
      helpdesk: "Ayuda",
      helpdeskDocuments: "Documentos de ayuda",
      judgement: "Dictamen",
      login: "Iniciar sesión",
      onboarding: "Incorporación",
      report: "Informe",
      resetPassword: "Restablecer contraseña",
      search: "Buscador",
      setNewPassword: "Establecer nueva contraseña",
      settings: "Ajustes",
      priceList: "Lista de precios",
    },
    twoFactorAuth: "Autenticación de dos factores",
    warningPopup: {
      header: "¿Estás seguro que deseas salir?",
      headerSave: "¡Por favor, completa todos los campos requeridos!",
      promptLogout:
        "Se cerrará la sesión automáticamente en PROMPT_TIME_MINUTES minuto por inactividad.",
      promptLogoutCountdown:
        "Se cerrará la sesión automáticamente en COUNTDOWN_TIME por inactividad.",
      logoutWarningTitle: "Tu sesión está a punto de expirar",
      promptLogoutInfo:
        "Por inactividad, se cerrará tu sesión automáticamente en un minuto.",
      stayLoggedIn: "Extender sesión",
      logoutNow: "Cerrar sesión ahora",
      text: "Los cambios realizados no se guardarán",
      textSave: "Los campos requeridos también pueden estar en otras pestañas",
    },
  },
  Contact: {
    header: "Soporte técnico",
  },
  WhatsNew: {
    closeButton: "Entendido",
  },
  LicenseExpire: {
    popup: {
      header: "Atención!",
      messageManyDaysBold:
        "La validez de la licencia o de la cuenta expira en %cnt% días.",
      messageOneDayBold:
        "La validez de la licencia o de la cuenta expira en %cnt% día.",
      messageRest:
        "Contacte con nosotros para mantener la continuidad del trabajo y el acceso a todas las funciones del sistema.",
      understandButton: "Entendido",
      dontShowAgain: "No mostrar más",
    },
    expiredPopup: {
      header: "Licencia expirada",
      message:
        "Su licencia para realizar pruebas en el sistema Optimis ha expirado.",
      okButton: "Aceptar",
    },
  },
  Cookies: {
    consent:
      "Para ofrecer servicios del más alto nivel, utilizamos cookies. El uso de nuestro sitio web significa que se almacenarán en su dispositivo. Puede cambiar la configuración de su navegador en cualquier momento.",
    cookiePolicy: {
      moduleText1:
        "El servicio utiliza cookies. En el siguiente documento, informamos sobre el uso de cookies en el servicio Optimis.",
      moduleText10:
        "Menú > Preferencias > Privacidad > Cookies – seleccione la opción apropiada.",
      moduleText2:
        "Las cookies son pequeños fragmentos de texto, código, que se envían al navegador y que el navegador devuelve. Algunas cookies a veces se guardan en un dispositivo determinado mientras se navega por el servicio Optimis. Existen diferentes tipos de cookies. Las cookies utilizadas en el servicio Optimis se han dividido en las siguientes categorías:\n      a. cookies necesarias\n      b. funcionales\n      c. analíticas",
      moduleText3:
        "a. Las cookies que son necesarias para el uso del servicio Optimis sirven, entre otras cosas, para garantizar la estabilidad de su funcionamiento (miden el tráfico y nos protegen contra la sobrecarga). Estas cookies son absolutamente necesarias para que el servicio Optimis pueda prestar servicios y/o únicamente con el fin de transmitir servicios y/o el servicio Optimis.\n      b. Cookies funcionales - recordar las preferencias de privacidad seleccionadas, los formularios en línea completados, recordar la configuración del sitio web.",
      moduleText4:
        "Al visitar el sitio web www.gov.pl, se mostrará un mensaje informando que utiliza cookies.",
      moduleText5:
        "En la mayoría de los navegadores de Internet, puede: eliminar cookies del disco duro de su computadora (desde la configuración del navegador), bloquear todas las cookies enviadas o establecer una advertencia antes de guardarlas en el disco.\n      Debe tenerse en cuenta que los cambios en la configuración de estos archivos que impliquen limitar su uso pueden afectar a algunas funcionalidades disponibles en los sitios web que los utilizan.\n      A continuación, indicamos cómo cambiar la configuración de cookies en los navegadores más populares:",
      moduleText6:
        "Menú > Configuración > Privacidad y seguridad – seleccione la opción apropiada.",
      moduleText7:
        "Menú > Configuración > Cookies y permisos del sitio – seleccione la opción apropiada.",
      moduleText8:
        "Menú > Preferencias > Privacidad y seguridad > Cookies y datos del sitio – seleccione la opción apropiada.",
      moduleText9:
        "Menú > Configuración > Privacidad y seguridad – seleccione la opción apropiada.",
      moduleTitle1: "1. Introducción",
      moduleTitle10: "Safari",
      moduleTitle2: "2. ¿Qué son las cookies?",
      moduleTitle3: "3. ¿Qué cookies utilizamos?",
      moduleTitle4: "4. Consentimiento para el uso de cookies",
      moduleTitle5: "5. Modificación de la configuración de cookies",
      moduleTitle6: "Google Chrome",
      moduleTitle7: "Internet Explorer",
      moduleTitle8: "Mozilla Firefox",
      moduleTitle9: "Opera",
      title: "Política de cookies",
    },
    header: "Permiso para usar cookies",
    policy: "Política de cookies",
    showPolicy: "Ver política de cookies",
  },
  Dashboard: {
    emptyState: {
      header: "No hay examinados agregados recientemente",
      info: "Para ver la lista de examinados, agrega al menos uno.",
    },
    footer: {
      day: "dias",
      days: "dia",
      lastFailedLogin: "Último acceso fallido",
      lastLogin: "Último acceso",
      passwordExpired: "Su contraseña expirará en",
      versionLabel: "Versión",
    },
    header: "Personas añadidas recientemente",
    kebabMenu: {
      print: "Imprimir contrato",
      profile: "Ir al perfil del examinado",
    },
  },
  Directory: {
    defaultFolderName: "Carpeta predeterminada",
    emptyState: {
      header: "No hay examinados en la carpeta seleccionada",
      info: "Para ver la lista de examinados en la carpeta, añada al menos un examinado",
    },
    header: "Registro de examinados",
    kebabMenu: {
      addDirectory: "Añadir carpeta",
      addExaminee: "Añadir examinado",
      delete: "Eliminar carpeta",
      edit: "Editar nombre de la carpeta",
    },
    labels: {
      examineeCount: "Personas",
      name: "Nombre de la carpeta",
      owner: "Propietario",
    },
    popup: {
      create: "Introduzca el nombre de la carpeta",
      edit: "Cambiar nombre de la carpeta",
    },
    popups: {
      delete: {
        confirmationHeader: "¿Está seguro de que desea eliminar la carpeta?",
        confirmationText:
          "Una vez eliminada, la carpeta no podrá ser restaurada.",
        confirmationCheckboxLabel: "Sí, deseo eliminar la carpeta",
      },
    },
  },
  DirectoryPreview: {
    breadcrumbs: "Registro de examinados",
    headerPopup: "Mover examinados",
    kebabMenu: {
      delete: "Eliminar examinado",
      edit: "Editar datos del examinado",
      move: "Mover examinado",
    },
    labels: {
      firstName: "Nombre",
      lastModification: "Última actividad",
      lastName: "Apellidos",
      peselSlashIdentifier: "DNI / Identificador",
    },
  },
  MoveExamAndFoldersPopup: {
    header: "Mover exámenes y carpetas",
    userInfo: "Datos del usuario",
    examinations: "Número de exámenes",
    examAll: "todos los exámenes",
    examAssign: "exámenes asignados",
    examDone: "exámenes realizados",
    directories: "Carpetas del usuario",
    noDirectories: "Sin carpetas",
    selectTargetUser:
      "Seleccione el usuario al que desea transferir los exámenes y carpetas",
    selectTargetUserLabel: "Usuario destinatario",
    noActiveUsers: "No hay usuarios activos",
    moveButton: "Mover",
  },
  DocumentationManagement: {
    ExaminationCard: {
      examinationCourse: {
        addExaminationExtendedResults: "Añadir resultado adicional",
        careerHistory: "Historial laboral",
        cognitiveExtendedResultsHeader:
          "Evaluación y descripción de la capacidad intelectual y procesos cognitivos - resultados adicionales",
        cognitiveResultsHeader:
          "Evaluación y descripción de la capacidad intelectual y procesos cognitivos del examinado (dentro de la metodología recomendada)",
        conclusions: "Conclusiones",
        conclusionsRecomendation: "Conclusiones y recomendaciones",
        deletePopup: {
          confirmationText: "Sí, quiero eliminar el resultado",
          contentText:
            "Después de eliminar el resultado, puede restaurar su contenido original actualizando los datos",
          headerText: "¿Está seguro de que desea eliminar este resultado?",
        },
        examinationExtendedResultsHeader:
          "Nombre de la prueba y resultados adicionales",
        examinationExtendedResultsT2WHeader: "Adicional",
        examinationResultsHeader:
          "Nombre de la prueba y resultados (dentro de la metodología recomendada)",
        examinationResultsT2WHeader: "Metodología recomendada",
        forcedUpdateBody:
          "Para desbloquear el formulario, complete la Entrevista del Examen, seleccione un estándar en la pestaña Persona Examinada y actualice la Tarjeta de Examen con los Datos de la Entrevista y Resultados.",
        forcedUpdateHeader:
          "Actualizar Tarjeta de Examen con Datos de la Entrevista y Resultados",
        header:
          "Datos de la entrevista directa y observación de la persona examinada",
        methodology: "Métodos de examen y resultados",
        occupationalMedicineAdditionalInfo:
          "Información adicional - Medicina laboral",
        personalityExtendedResultsHeader:
          "Evaluación y descripción de la personalidad del examinado, incluyendo funcionamiento en situaciones difíciles y madurez social - resultados adicionales",
        personalityResultsHeader:
          "Evaluación y descripción de la personalidad del examinado, incluyendo funcionamiento en situaciones difíciles y madurez social (dentro de la metodología recomendada)",
        psychomotorExtendedResultsHeader:
          "Rendimiento psicomotor - resultados adicionales",
        psychomotorResultsHeader:
          "Rendimiento psicomotor (dentro de la metodología recomendada)",
        recommendations: "Recomendaciones",
      },
      examinee: {
        aim: "Objetivo del examen",
        chosenNormSet: "Estándar aplicado en el examen",
        entityDirectingToExamination: "Entidad que deriva al examen",
        examinationDate: "Fecha del examen",
        previousExaminationDate: "Fecha del examen anterior",
        t2dAim: {
          drivingInstructorAim:
            "Determinación de ausencia o presencia de contraindicaciones para desempeñar funciones de profesor/examinador/instructor de técnica de conducción.",
          drivingVehiclesAim:
            "Determinación de ausencia o presencia de contraindicaciones para la conducción de vehículos.",
          emergencyDriverAim:
            "Determinación de ausencia o presencia de contraindicaciones para conducir vehículos de emergencia o de transporte de valores.",
          professionalDriverAim:
            "Determinación de ausencia o presencia de contraindicaciones para desempeñar el puesto de conductor.",
        },
      },
      fetchUpdated: "Actualizar con datos de la entrevista y resultados",
      header: "Tarjeta de examen",
      headerTEST2ARMS: "Tarjeta de examen TEST2ARMS",
      headerTEST2DRIVE: "Tarjeta de examen TEST2DRIVE",
      headerTEST2SAFE: "Tarjeta de examen TEST2SAFE",
      headerTEST2WORK: "Tarjeta de examen TEST2WORK",
      judgment: {
        judgment: "Contenido del dictamen",
        justification: "Justificación del dictamen",
        justificationText: "Contenido de la justificación",
        recommendations: "Recomendaciones",
        result: "Resultado del examen psicológico",
        sent: "Dictamen/copia del dictamen enviado, si procede",
        t2d: {
          existing: "existen",
          lack: "no existen",
          questions: {
            drivingInstructorContraindication:
              "Contraindicaciones para desempeñar funciones de profesor/examinador/instructor de técnica de conducción.",
            drivingVehiclesContraindication:
              "Contraindicaciones para la conducción de vehículos.",
            emergencyVehicleDriverContraindication:
              "Contraindicaciones para conducir vehículos de emergencia o de transporte de valores.",
            professionalDriverContraindication:
              "Contraindicaciones para desempeñar el puesto de conductor.",
          },
        },
        to: "para",
      },
      tabs: {
        courseOfExamination: "Curso del examen",
        examinee: "Persona examinada",
        results: "Resultados del examen psicológico",
      },
      tooltipFetchUpdated:
        "Esta acción eliminará todos los cambios no guardados del Curso del Examen",
      tooltipFetchUpdatedDisabled:
        "Para desbloquear esta acción, seleccione el estándar de examen.",
    },
    consultation: {
      breadcrumbs: "Consulta psicológica",
      examineeData: "Datos del examinado",
      statement: "declaro",
    },
    emptyState: {
      header: "El examen no se ha completado",
    },
    judgment: {
      ART_1: "art. 39k apartado 3 punto 1",
      ART_2: "art. 39k apartado 3 punto 2",
      appeal: "Este dictamen puede ser apelado ante",
      appealDate: "En el plazo de",
      appealDay: "En el plazo de",
      appealDay2: "días desde su recepción",
      appealDayTlt: "Número de días",
      civilExplosives: {
        false:
          "presenta alteraciones en el funcionamiento psicológico y por lo tanto no puede realizar actividades relacionadas con la adquisición y almacenamiento de explosivos destinados a uso civil",
        true: "no presenta alteraciones en el funcionamiento psicológico y por lo tanto puede realizar actividades relacionadas con la adquisición y almacenamiento de explosivos destinados a uso civil",
      },
      drivingExaminer: {
        false:
          "presenta contraindicaciones para desempeñar funciones de profesor/examinador/instructor de técnica de conducción",
        true: "no presenta contraindicaciones para desempeñar funciones de profesor/examinador/instructor de técnica de conducción",
      },
      drivingInstructor: {
        false:
          "presenta contraindicaciones para desempeñar funciones de profesor/examinador/instructor de técnica de conducción",
        true: "no presenta contraindicaciones para desempeñar funciones de profesor/examinador/instructor de técnica de conducción",
      },
      drivingLicense: "En relación al permiso de conducir clase",
      drivingVehicles: {
        false:
          "presenta contraindicaciones psicológicas para la conducción de vehículos",
        true: "no presenta contraindicaciones psicológicas para la conducción de vehículos",
      },
      emergencyVehicleDriver: {
        false:
          "existen contraindicaciones para conducir vehículos de emergencia o de transporte de valores",
        true: "no existen contraindicaciones para conducir vehículos de emergencia o de transporte de valores",
      },
      examiner_ART_1: "art. 34 apartado 5 punto 1",
      examiner_ART_2: "art. 34 apartado 5 punto 2",
      firearmLicense: {
        false:
          "pertenece a las personas mencionadas en el Art. 15 párrafo 1 punto 3 de la Ley del 21 de mayo de 1999 sobre armas y municiones y no puede poseer armas",
        true: "no pertenece a las personas mencionadas en el Art. 15 párrafo 1 punto 3 de la Ley del 21 de mayo de 1999 sobre armas y municiones y puede poseer armas",
      },
      header: {
        base: "Dictamen",
        baseAppeal: "Dictamen de apelación",
        baseAppealFooter: "Este dictamen es definitivo.",
        civilExplosives: "Actividad autorizada - para uso civil",
        civilExplosivesAppeal:
          "Actividad autorizada - para uso civil - apelación",
        driver: "Conducción de vehículos",
        drivingExaminer: "Examinador",
        drivingInstructor: "Profesor",
        emergencyVehicleDriver: "Conductor de vehículo de emergencia",
        firearmLicense: "Licencia de armas",
        militaryExplosives: "Actividad autorizada - de uso militar o policial",
        occupationalMedicine: "Medicina laboral",
        physicalProtection: "Vigilante de seguridad",
        profesionalDriver: "Puesto de conductor",
      },
      isAppealTitle: "DICTAMEN DE APELACIÓN",
      judgmentNumber: "Dictamen psicológico nº",
      judgmentNumberAppeal: "Dictamen psicológico nº",
      legalBais: "Base legal del examen",
      militaryExplosives: {
        false:
          "presenta alteraciones significativas en el funcionamiento psicológico que impiden realizar o dirigir actividades comerciales en el ámbito de fabricación y comercio de explosivos, armas, municiones y productos y tecnología de uso militar o policial",
        true: "no presenta alteraciones significativas en el funcionamiento psicológico que impidan realizar o dirigir actividades comerciales en el ámbito de fabricación y comercio de explosivos, armas, municiones y productos y tecnología de uso militar o policial",
      },
      nextLegalBasis: "Base legal para el próximo examen:",
      occupationalMedicine: {
        false: "presenta contraindicaciones psicológicas para",
        justification: "Justificación",
        true: "no presenta contraindicaciones psicológicas para",
      },
      occupationalMedicineStatement: "Dictamino*",
      physicalProtection: {
        false:
          "no es apto para desempeñar las funciones de vigilante de seguridad",
        true: "es apto para desempeñar las funciones de vigilante de seguridad",
      },
      professionalDriver: {
        false:
          "presenta contraindicaciones psicológicas para desempeñar el puesto de conductor",
        true: "no presenta contraindicaciones psicológicas para desempeñar el puesto de conductor",
      },
      remarks: "Observaciones",
      statement: "Declaro*",
      statementThat: "Declaro que",
    },
    names: {
      CivilExplosivesJudgment:
        "Dictamen sobre armas y explosivos para uso civil",
      CivilExplosivesJudgmentTEST2ARMS:
        "Dictamen sobre armas y explosivos para uso civil",
      CivilExplosivesJudgmentTEST2DRIVE:
        "Dictamen sobre armas y explosivos para uso civil",
      CivilExplosivesJudgmentTEST2SAFE:
        "Dictamen sobre armas y explosivos para uso civil",
      CivilExplosivesJudgmentTEST2WORK:
        "Dictamen sobre armas y explosivos para uso civil",
      DriverJudgment: "Dictamen de conducción de vehículos",
      DriverJudgmentTEST2ARMS: "Dictamen de conducción de vehículos",
      DriverJudgmentTEST2DRIVE: "Dictamen de conducción de vehículos",
      DriverJudgmentTEST2SAFE: "Dictamen de conducción de vehículos",
      DriverJudgmentTEST2WORK: "Dictamen de conducción de vehículos",
      DrivingExaminerJudgment: "Dictamen de examinador de conducción",
      DrivingExaminerJudgmentTEST2ARMS: "Dictamen de examinador de conducción",
      DrivingExaminerJudgmentTEST2DRIVE: "Dictamen de examinador de conducción",
      DrivingExaminerJudgmentTEST2SAFE: "Dictamen de examinador de conducción",
      DrivingExaminerJudgmentTEST2WORK: "Dictamen de examinador de conducción",
      DrivingInstructorJudgment: "Dictamen de profesor de autoescuela",
      DrivingInstructorJudgmentTEST2ARMS: "Dictamen de profesor de autoescuela",
      DrivingInstructorJudgmentTEST2DRIVE:
        "Dictamen de profesor de autoescuela",
      DrivingInstructorJudgmentTEST2SAFE: "Dictamen de profesor de autoescuela",
      DrivingInstructorJudgmentTEST2WORK: "Dictamen de profesor de autoescuela",
      DrivingTechniqueInstructorJudgment:
        "Dictamen de instructor de técnica de conducción",
      EmergencyVehicleDriverJudgment: "Dictamen de vehículos de emergencia",
      EmergencyVehicleDriverJudgmentTEST2ARMS:
        "Dictamen de vehículos de emergencia",
      EmergencyVehicleDriverJudgmentTEST2DRIVE:
        "Dictamen de vehículos de emergencia",
      EmergencyVehicleDriverJudgmentTEST2SAFE:
        "Dictamen de vehículos de emergencia",
      EmergencyVehicleDriverJudgmentTEST2WORK:
        "Dictamen de vehículos de emergencia",
      ExaminationCard: "Tarjeta de examen",
      ExaminationCardTEST2ARMS: "Tarjeta de examen TEST2ARMS",
      ExaminationCardTEST2DRIVE: "Tarjeta de examen TEST2DRIVE",
      ExaminationCardTEST2SAFE: "Tarjeta de examen TEST2SAFE",
      ExaminationCardTEST2WORK: "Tarjeta de examen TEST2WORK",
      FirearmLicenseJudgment: "Dictamen de licencia de armas",
      FirearmLicenseJudgmentTEST2ARMS: "Dictamen de licencia de armas",
      FirearmLicenseJudgmentTEST2DRIVE: "Dictamen de licencia de armas",
      FirearmLicenseJudgmentTEST2SAFE: "Dictamen de licencia de armas",
      FirearmLicenseJudgmentTEST2WORK: "Dictamen de licencia de armas",
      MilitaryExplosivesJudgment:
        "Dictamen de armas y material policial o militar",
      MilitaryExplosivesJudgmentTEST2ARMS:
        "Dictamen de armas y material policial o militar",
      MilitaryExplosivesJudgmentTEST2DRIVE:
        "Dictamen de armas y material policial o militar",
      MilitaryExplosivesJudgmentTEST2SAFE:
        "Dictamen de armas y material policial o militar",
      MilitaryExplosivesJudgmentTEST2WORK:
        "Dictamen de armas y material policial o militar",
      OccupationalMedicineJudgmentTEST2ARMS: "Dictamen de medicina laboral",
      OccupationalMedicineJudgmentTEST2DRIVE: "Dictamen de medicina laboral",
      OccupationalMedicineJudgmentTEST2SAFE: "Dictamen de medicina laboral",
      OccupationalMedicineJudgmentTEST2WORK: "Dictamen de medicina laboral",
      PhysicalProtectionJudgment: "Dictamen de vigilante de seguridad",
      PhysicalProtectionJudgmentTEST2ARMS: "Dictamen de vigilante de seguridad",
      PhysicalProtectionJudgmentTEST2DRIVE:
        "Dictamen de vigilante de seguridad",
      PhysicalProtectionJudgmentTEST2SAFE:
        "Dictamen de vigilante de seguridad física",
      PhysicalProtectionJudgmentTEST2WORK: "Dictamen de vigilante de seguridad",
      ProfessionalDriverJudgment: "Dictamen de conductor profesional",
      ProfessionalDriverJudgmentTEST2ARMS: "Dictamen de conductor profesional",
      ProfessionalDriverJudgmentTEST2DRIVE: "Dictamen de conductor profesional",
      ProfessionalDriverJudgmentTEST2SAFE: "Dictamen de conductor profesional",
      ProfessionalDriverJudgmentTEST2WORK: "Dictamen de conductor profesional",
      PsychologicalConsultation: "Consulta psicológica",
      PsychologicalConsultationTEST2ARMS: "Consulta psicológica",
      PsychologicalConsultationTEST2DRIVE: "Consulta psicológica",
      PsychologicalConsultationTEST2SAFE: "Consulta psicológica",
      PsychologicalConsultationTEST2WORK: "Consulta psicológica",
      PsychologicalOpinion: "Informe psicológico",
      PsychologicalOpinionTEST2ARMS: "Informe psicológico",
      PsychologicalOpinionTEST2DRIVE: "Informe psicológico",
      PsychologicalOpinionTEST2SAFE: "Informe psicológico - Detectives",
      PsychologicalOpinionTEST2WORK: "Informe psicológico",
    },
    opinion: {
      breadcrumbs: "Informe psicológico",
      breadcrumbsAppeal: "Informe psicológico de apelación",
      examineeData: "Datos del examinado",
      statement: "EN BASE AL EXAMEN PSICOLÓGICO REALIZADO, DECLARO",
    },
    report: {
      details: {
        PESEL: "DNI",
        assignDate: "Fecha de asignación del examen",
        endDate: "Fecha de finalización del examen",
        firstName: "Nombre",
        idExamination: "ID del examen",
        identificationNumber: "Identificador",
        lastName: "Apellidos",
        name: "Nombre del examen",
        status: "Estado del examen",
      },
      header: {
        interval: "Seleccione el intervalo de confianza",
        language: "Seleccione el idioma del informe",
        recipient: "Seleccione el destinatario",
        reportDiagnostic: "Informe diagnóstico",
        reportDiagnosticCharts: "Informe diagnóstico con gráficos",
        reportInterpretation: "Informe interpretativo",
        standard: "Seleccione el estándar",
      },
      statusExamination: {
        skip: "Algunas pruebas fueron omitidas o interrumpidas",
      },
    },
    snackbar: {
      save: "Documento guardado correctamente",
    },
  },
  Email: {
    bodybreak:
      '<div style="color: #000000; font-family: Arial;font-size:12pt;line-height: 1.5rem;">\n  <p>Estimados Señores,<br/><br/>\n  Les informamos que el <strong>[fecha, ej., 30 de junio de 2025]</strong> entre las <strong>[ej., 22:00 - 02:00]</strong> realizaremos un mantenimiento técnico programado para actualizar nuestro sistema.<br/>Durante los trabajos, el acceso al sistema Optimis puede estar temporalmente limitado o no disponible. Por favor planifiquen su trabajo con el sistema teniendo en cuenta este período de mantenimiento<br /><br />\n  \n  Nos disculpamos por cualquier inconveniente y agradecemos su comprensión.<br /><br />En caso de preguntas, por favor contacten con nosotros<br/>email: <strong>alta@alta.pl</strong><br/>teléfono:<strong>(+48) 515 131 941</strong><br /><br />\n  \n  Este mensaje fue generado automáticamente - por favor no responda a él.\n  <br/><br>\n  Saludos cordiales,\n  Equipo ALTA </p>\n  </div>',
    bodysys:
      '<div style="color: #000000; font-family: Arial;font-size:12pt;line-height: 1.5rem;">\n  <p>Estimados Señores,<br/><br/>\n  Les informamos que durante el período festivo, del <strong>24 de diciembre de 2025</strong> al <strong>1 de enero de 2026</strong>, nuestro servicio de ayuda estará cerrado.<br/>El sistema OPTIMIS permanecerá completamente disponible y funcionará sin cambios.<br /><br />\n  \n  En caso de asuntos urgentes, por favor contacten con nosotros después del descanso festivo<br/>email: <strong>alta@alta.pl</strong><br/>teléfono:<strong>(+48) 515 131 941</strong><br /><br />\n  ¡Gracias por su comprensión y les deseamos unas fiestas tranquilas y alegres!<br /><br />\n  \n  Este mensaje fue generado automáticamente - por favor no responda a él.\n  <br/><br>\n  Saludos cordiales,\n  Equipo ALTA </p>\n  </div>',
    bodyupdate:
      '<div style="color: #000000; font-family: Arial;font-size:12pt;line-height: 1.5rem;">\n  <p>Estimados Señores,<br/><br/>\n  Nos complace informarles que hemos completado la actualización del sistema <strong>OPTIMIS</strong>, que tuvo lugar el [30 de junio de 2025].<br />Los cambios implementados tienen como objetivo mejorar la funcionalidad y comodidad de uso.<br/><br/>A continuación presentamos las novedades clave:<br /><br />\n  <ol>\n  <li><strong>Nueva interfaz de usuario</strong>: Aspecto renovado y navegación más intuitiva.</li>\n  <li><strong>Mejora del rendimiento</strong>: Tiempo de carga reducido y procesamiento de datos más rápido.</li>\n  <li><strong>Nuevas funciones</strong>: Se han añadido [ej., posibilidad de personalizar configuraciones, integración con nuevas herramientas, informes en tiempo real].</li>\n  <li><strong>Seguridad mejorada</strong>: Se han implementado salvaguardas adicionales para proteger los datos de los usuarios.</li>\n  </ol>\n  \n  El sistema está completamente disponible y todas las funciones funcionan según lo previsto.<br/><br/>En caso de preguntas o necesidad de soporte, les invitamos a contactar con nuestro equipo<br/>email: <strong>alta@alta.pl</strong><br/>teléfono:<strong>(+48) 515 131 941</strong><br /><br />\n  ¡Gracias por su confianza y les invitamos a explorar las nuevas capacidades del sistema!<br /><br />\n  \n  Este mensaje fue generado automáticamente - por favor no responda a él.\n  <br/><br>\n  Saludos cordiales,\n  Equipo ALTA </p>\n  </div>',
    subjectbreak: "Mantenimiento Técnico",
    subjectsys: "Descanso Festivo",
    subjectupdate: "Actualización de Software",
  },
  ExaminationAssignmentView: {
    header: "Asignar la evaluación",
    labels: {
      chooseExaminationType: "Elegir tipo de examen",
      chooseLawBase: "Elegir base legal para el examen",
      description: "Descripción",
      legalBase: "Base legal para el examen",
      methodologyTest2Arms:
        "TEST2ARMS - metodología de pruebas psicológicas, actividad con licencia",
      methodologyTest2Drive:
        "TEST2DRIVE - metodología para realizar exámenes de conductores en psicología del transporte",
      methodologyTest2Safe:
        "TEST2SAFE - metodología de pruebas psicológicas para personal de seguridad y detectives",
      methodologyTest2Work:
        "TEST2WORK - metodología de pruebas psicológicas en medicina ocupacional",
      methodologyTest2SafeTlt: "TEST2SAFE",
      methodologyTest2DriveTlt: "TEST2DRIVE",
      methodologyTest2ArmsTlt: "TEST2ARMS",
      methodologyTest2WorkTlt: "TEST2WORK",
      methodologyTest2SafeDesc:
        "metodología de pruebas psicológicas para personal de seguridad y detectives",
      methodologyTest2DriveDesc:
        "metodología para realizar exámenes de conductores en psicología del transporte",
      methodologyTest2ArmsDesc:
        "metodología de pruebas psicológicas, actividad con licencia",
      methodologyTest2WorkDesc:
        "metodología de pruebas psicológicas en medicina ocupacional",
      reason: "Propósito del examen",
      suggestedTestMethods: "METODOLOGÍAS SUGERIDAS",
      freeCredits: "créditos disponibles: ",
      lockedCredits: "créditos bloqueados en exámenes asignados: ",
      selectedTestCredits: "créditos por tests seleccionados: ",
    },
    license: "Prueba no disponible en la licencia adquirida",
    testAlreadyInExamination: "Este test ya está disponible en el examen",
    popup: {
      checkbox: "Recordar elección para todos los examinados",
      content: "¿Está seguro de que desea omitir estas pruebas?",
      header:
        "Algunas pruebas recomendadas para la metodología seleccionada han sido desactivadas.",
      headerCredits: "Atención",
      contentCredits:
        "No se puede seleccionar el test porque la suma de créditos por los tests seleccionados supera el número de créditos disponibles.",
    },
  },
  ExaminationList: {
    deletePopup: {
      confirmationText: "Sí, quiero eliminar el examen",
      contentText: "Después de eliminar el examen, no será posible restaurarlo",
      headerText: "¿Está seguro de que desea eliminar el examen?",
    },
    noTestsPopup: {
      headerText: "No hay tests para agregar",
      content:
        "No se pueden agregar más tests a este examen. Todos los tests disponibles en su licencia ya están asignados a este examen.",
    },
    kebabMenu: {
      delete: "Eliminar examen",
    },
    labels: {
      assign: "Asignado",
      assignDate: "Fecha de asignación",
      assignDateMobile: "Añadido",
      contract: "Contrato",
      create: "Creado",
      createDate: "Fecha de creación",
      documentation: "Documentación",
      end: "Finalizado",
      endDate: "Fecha de finalización",
      identificator: "ID",
      interview: "Entrevista",
      language: "Idioma",
      nameArchiveExamination: "Nombre de la batería",
      nameExamination: "Nombre del examen",
      start: "Iniciado",
      startDate: "Fecha de inicio",
      testCnt: "Tests",
      creditsCnt: "Créditos",
      extendExamMobile: "Agregar tests",
      recalculateExamMobile: "Recalcular",
      examTlt: "El examen contiene:",
      methodologyNameTlt: "metodologías:",
      testNameTlt: "tests:",
    },
    toolTip: {
      contract: "Generar contrato",
      delete: "Eliminar",
      documentation: "Documentación",
      interview: "Entrevista",
      blocked: "examen bloqueado por falta de créditos",
      extendExam: "Añadir tests al examen",
      extendExamHidden: "Función oculta (parámetro SHOW_EXTENDED_EXAM=0)",
      recalculateExam: "Recalcular examen",
      recalculateExamHidden:
        "Función oculta (parámetro SHOW_RECALCULATE_EXAM=0 o se requiere administrador del laboratorio)",
    },
    withoutLegalBasis: "Examen sin base legal",
  },
  ExaminationView: {
    aimsKind: {
      aimKind_1: "Opinión psicológica - detectives",
      aimKind_10:
        "Certificado - actividad licenciada para fines militares o policiales",
      aimKind_11: "Certificado - actividad licenciada para fines civiles",
      aimKind_12:
        "Certificado de apelación - actividad licenciada para fines civiles",
      aimKind_13: "Certificado - medicina ocupacional",
      aimKind_14: "Certificado - medicina ocupacional minería y rescate minero",
      aimKind_15: "Certificado - medicina ocupacional licencia de maquinista",
      aimKind_16:
        "Certificado - conductor categoría C1, C1+E, C, C+E, D1, D1+E, D y D+E o conducción de tranvía",
      aimKind_17:
        "Certificado - restitución de licencia de conductor categoría AM, A1, A2, A, B1, B, B+E y T",
      aimKind_18:
        "Certificado - restitución de licencia de conductor contraindicaciones psicológicas",
      aimKind_19:
        "Certificado - extensión de licencia categoría C1, C1+E, C, C+E, D1, D1+E, D y D+E o conducción de tranvía",
      aimKind_20: "Certificado - examen post-accidente del conductor",
      aimKind_21:
        "Certificado - examen del conductor después del consumo de alcohol o sustancias similares",
      aimKind_22:
        "Certificado - examen del conductor después de exceder 24 puntos",
      aimKind_23:
        "Certificado - examen del conductor después de al menos 2 infracciones",
      aimKind_24:
        "Certificado - examen del conductor contraindicaciones psicológicas",
      aimKind_25: "Certificado - conductor de vehículo de emergencia",
      aimKind_26:
        "Certificado - examen post-accidente del conductor (referido por el starost)",
      aimKind_27: "Certificado - desempeño de funciones de instructor",
      aimKind_28: "Certificado - desempeño de funciones de examinador",
      aimKind_29:
        "Certificado - estudiante conductor o candidato para escuela secundaria categoría C o C+E",
      aimKind_3: "Certificado - trabajador de seguridad física",
      aimKind_30:
        "Certificado - estudiante conductor o candidato para curso vocacional categoría C o C+E",
      aimKind_31: "Certificado - conductor profesional referido por empleador",
      aimKind_32: "Certificado - conductor profesional autónomo",
      aimKind_8: "Certificado de apelación - trabajador de seguridad física",
      aimKind_9: "Certificado - permiso de armas",
    },
    breadcrumbs: {
      archive: "Exámenes archivados",
    },
    common: {
      unavailableInLanguageOption: "No disponible en el idioma seleccionado.",
    },
    details: {
      createDate: "Creación del examen",
      endDate: "Finalización del examen",
      identificator: "ID del examen",
      language: "Idioma",
      name: "Nombre del examen",
      startDate: "Fecha de inicio del examen",
      type: "Nombre de la batería",
    },
    header: "Documentación",
    labels: {
      details: "Detalles",
      download: "Descargar",
      edit: "Editar",
      generate: "Generar",
      name: "Nombre de la prueba",
      nameFile: "Nombre del archivo",
      print: "Imprimir",
      result: "Resultado",
      type: "Tipo de documento",
    },
    protocols: {
      language: "Idioma de los protocolos",
      testProtocol: "Protocolo de prueba",
      noProtocol: "No hay protocolos de prueba para el examen seleccionado",
    },
    tabs: {
      documentation: "Documentación",
      protocols: "Protocolos",
      reports: "Informes",
    },
  },
  ExamineeList: {
    labels: {
      added: "Agregado",
      allFinishExam: "Asignado / completado",
      contract: "Contrato",
      examine: "Examen",
      examineLastDate: "Fecha del último examen",
      firstName: "Nombre",
      folder: "Carpeta",
      lastName: "Apellido",
      peselSlashIdentifier: "PESEL / Identificador",
      profile: "Ver perfil",
      profileShort: "Perfil",
    },
  },
  ExamineeManagment: {
    breadcrumbs: {
      add: "Agregar sujeto",
      dashboard: "Panel de usuario",
      directories: "Registro de sujetos",
      edit: "Editar sujeto",
      import: "Importar examinados",
    },
    header: {
      add: "Agregar nuevo sujeto",
      edit: "Editar datos del sujeto",
      editMobile: "Editar datos",
      import: "Importar examinados",
    },
    importExaminees: {
      collapse: "contraer",
      errors: {
        fileReadFailed: "Error en la lectura del archivo.",
        invalidPesel:
          "El archivo de importación contiene números PESEL inválidos.",
        invalidPeselFound:
          "El archivo de importación contiene números PESEL inválidos.",
        readFileError: "Error al leer el contenido del archivo.",
      },
      expand: "expandir",
      fileDesc:
        "Para importar datos se requiere un archivo CSV. Asegúrese de que su archivo cumpla con los siguientes criterios:",
      fileDesc1: "1. Encabezado:",
      fileDesc10: "Apellido.",
      fileDesc11: "pesel:",
      fileDesc12: "Número PESEL. Déjelo en blanco si no desea proporcionarlo.",
      fileDesc13: "sexo:",
      fileDesc14: "Género - escriba male (hombre) o female (mujer).",
      fileDesc15: "cumpleaños:",
      fileDesc16: "Fecha de nacimiento en formato aaaa-mm-dd (ej. 1985-03-21).",
      fileDesc17: "Ejemplo de contenido del archivo CSV:",
      downloadCsvExample: "Descargar archivo CSV de ejemplo",
      fileDesc18:
        "nombre,apellido,pesel,sexo,cumpleaños,anónimo,correo,teléfono",
      fileDesc19: "Juan,García,85032112345,male,1985-03-21,0",
      fileDesc2:
        "La primera fila del archivo debe contener exactamente los siguientes nombres de columnas:",
      fileDesc20: "Ana,Martínez,,female,1992-07-10,0",
      fileDesc21: "Examinado,Anónimo,,male,1995-12-25,1",
      fileDesc22: "Explicación del ejemplo:",
      fileDesc23: "La primera fila es el encabezado requerido.",
      fileDesc24:
        "La segunda fila contiene los datos completos de Juan García.",
      fileDesc25:
        "La tercera fila contiene datos de Ana Martínez, pero el campo pesel se deja intencionalmente en blanco porque no proporcionaremos el número PESEL para esta persona.",
      fileDesc26: "La cuarta fila contiene los datos completos de Pedro López.",
      fileDesc27:
        "Por favor, prepare el archivo de acuerdo con las instrucciones anteriores para garantizar una importación de datos exitosa.",
      fileDesc28: "anónimo:",
      fileDesc29:
        "Examinado anónimo. 1 - examinado anónimo, no se le pedirá consentimiento para procesar datos personales, no puede tener PESEL. 0 - examinado con datos personales",
      fileDesc3: "nombre, apellido, pesel, sexo, cumpleaños, anónimo",
      fileDesc30: "correo:",
      fileDesc31:
        "Dirección de correo electrónico. Déjalo vacío si no quieres proporcionarlo.",
      fileDesc32: "teléfono:",
      fileDesc33:
        "Número de teléfono. Déjalo vacío si no quieres proporcionarlo.",
      fileDesc4: "2. Datos:",
      fileDesc5:
        "Cada fila siguiente debe contener datos para una persona, según el orden de las columnas en el encabezado.",
      fileDesc6: "3. Formato de datos:",
      fileDesc7: "nombre:",
      fileDesc8: "Nombre.",
      fileDesc9: "apellido:",
      filePattern: "Formato del archivo de importación",
      importFile: "subir archivo CSV",
      noFileSelected: "-",
      saveSuccess: "Examinados importados con éxito.",
      success: "Archivo de importación cargado con éxito.",
      tltFileSelected: "vista previa del archivo de importación: ",
    },
  },
  ExamineeView: {
    anonymity: "Sujeto anónimo",
    drivingLicense: {
      a: "A",
      a1: "A1",
      a2: "A2",
      am: "AM",
      b: "B",
      b1: "B1",
      be: "B+E",
      c: "C",
      c1: "C1",
      c1e: "C1+E",
      ce: "C+E",
      d: "D",
      d1: "D1",
      d1e: "D1+E",
      de: "D+E",
      t: "T",
      tramwaj: "TRAMWAJ",
    },
    emptyState: {
      header: "No hay exámenes asignados a este sujeto",
      info: "Para ver la lista de exámenes, asigne al menos un examen.",
    },
    kebabMenu: {
      delete: "Eliminar sujeto",
      edit: "Editar datos del sujeto",
    },
    tabs: {
      archive: "Exámenes archivados",
      data: "Datos del sujeto",
      examination: "Exámenes",
    },
    translations: {
      basicIndustry: "formación técnica básica",
      basicVocational: "formación profesional básica",
      female: "mujer",
      higher: "educación superior",
      id_card: "documento de identidad",
      lowerSecondary: "educación secundaria básica",
      male: "hombre",
      passport: "pasaporte",
      primary: "educación primaria",
      secondary: "educación secundaria",
      secondaryIndustry: "formación técnica media",
    },
    userData: {
      address: "Dirección",
      birthDate: "Fecha de nacimiento",
      defaultAnonFirstName: "Sujeto",
      defaultAnonLastName: "Anónimo",
      drivingLicense: "Categoría de permiso de conducir",
      drivingLicenseIssuer: "Autoridad emisora del permiso de conducir",
      education: "Educación",
      email: "Dirección de correo electrónico",
      examineName: "Nombre y apellidos",
      identificator: "Identificador",
      identityCard: "Documento de identidad",
      pesel: "Número de identificación personal",
      phone: "Número de teléfono",
      serialNumber: "Número de serie",
      sex: "Sexo",
    },
  },
  ExportResults: {
    exportActivities: "Exportar a archivo XLS",
    header: "Exportar resultados de exámenes",
    headerMobile: "Exportar resultados de exámenes",
    popups: {
      delete: {
        confirmationHeader:
          "¿Está seguro de que desea eliminar el archivo de exportación?",
        confirmationText:
          "Después de eliminar el archivo de exportación, no será posible restaurarlo.",
        confirmationCheckboxLabel:
          "Sí, deseo eliminar el archivo de exportación",
      },
    },
  },
  StatsExport: {
    popups: {
      delete: {
        confirmationHeader:
          "¿Está seguro de que desea eliminar el archivo de estadísticas?",
        confirmationText:
          "Después de eliminar el archivo de estadísticas, no será posible restaurarlo.",
        confirmationCheckboxLabel:
          "Sí, deseo eliminar el archivo de estadísticas",
      },
    },
  },
  FormLabels: {
    currentPassword: "Contraseña actual",
    email: "Correo electrónico",
    newPassword: "Nueva contraseña",
    password: "Contraseña",
    pin: "PIN",
  },
  FormValidation: {
    Password: {
      camelCase: "una mayúscula, una minúscula",
      length: "Mínimo %lenght% caracteres",
      number: "un número",
      settings: "Debe contener:",
      spacialChar: "un carácter especial",
    },
    Pin: {
      length: "Debe contener 4 dígitos",
    },
    max: "El nombre no puede exceder los 128 caracteres",
    required: "Este campo es obligatorio",
  },
  FormValidationErrors: {
    email: "El valor introducido no es una dirección de correo electrónico",
    required: "Este campo es obligatorio",
    passwordMinLength:
      "Su contraseña debe tener al menos %{minLength} caracteres",
    passwordRequirements:
      "Su contraseña no cumple con todas las condiciones requeridas",
    pinLength: "El PIN debe tener exactamente 4 dígitos",
    pinDigitsOnly: "El PIN solo puede contener dígitos",
  },
  Format: {
    ExamineeViewDateFormat: "DD.MM.YYYY",
    FormDateFormat: "D MMMM YYYY",
    ViewDateTime: "DD.MM.YYYY HH:mm",
  },
  Forms: {
    adminFields: {
      activityDetails: "Detalles",
      activityName: "actividad",
      address: "Calle y número",
      cin: "Número de registro",
      city: "Ciudad",
      clientId: "ID del cliente",
      dateExpire: "Validez de la cuenta",
      dateFrom: "rango desde",
      dateLicExpire: "Fecha de vencimiento de la licencia",
      dateTo: "rango hasta",
      email: "Correo electrónico",
      examineesCnt: "Examinados",
      firstName: "Nombre",
      isActive: "Estado de la cuenta",
      isStaff: "Rol",
      isSuperuser: "Usuario con privilegios de administrador",
      isAdmin: "Administrador",
      allowAllAccounts: "Acceso a todas las cuentas",
      allowAllOwnAndCreated: "Acceso a cuenta propia y cuentas creadas",
      lastName: "Apellidos",
      licMethodologies: "Metodologías disponibles",
      licTests: "Pruebas disponibles",
      methodologyTlt: "Metodología",
      name: "Nombre",
      no: "no",
      password: "Contraseña",
      pin: "Código PIN",
      postalCode: "código postal",
      pwdCamelCase: "Letras mayúsculas y minúsculas",
      pwdLength: "Longitud de la contraseña",
      pwdNumbers: "Dígito",
      pwdSpecialChar: "Carácter especial",
      creditsLic: "Licencia de créditos",
      credits: "Créditos",
      remainingCredits: "Créditos pendientes de utilizar",
      allCredits: "Créditos adquiridos",
      lockedCredits: "Créditos bloqueados en exámenes",
      status: "estado",
      testCogTlt: "pruebas cognitivas",
      testPersonTlt: "pruebas de personalidad",
      testPsychMotorTlt: "pruebas psicomotoras",
      theme: "Apariencia",
      tin: "NIF/CIF",
      usersCnt: "Usuarios",
      yes: "sí",
    },
    adminOptions: {
      admin: {
        admin: "administrador",
        baseuser: "registrador",
        user: "usuario",
      },
      status: {
        active: "activo",
        disabled: "inactivo",
      },
      theme: {
        defaultTheme: "predeterminado",
        optimisTheme: "optimis",
      },
    },
    adminSnackbar: {
      email_unique_error:
        "¡Este correo electrónico ya existe en la base de datos!",
      email_wrong_error: "¡El correo electrónico proporcionado no es válido!",
      invalidDate: "La fecha de envío no puede ser anterior a la fecha actual",
      parametersSaved: "Parámetros guardados correctamente",
      required: "Por favor, complete todos los campos obligatorios.",
    },
    anonymous: "Examen anónimo",
    emailSender: {
      dateSend: "fecha de envío",
      emailSentSuccessed:
        "Los mensajes se han guardado y se enviarán en el momento programado",
      emailType: "tipo de mensaje",
      muiRTEtextPlaceHolder: "Contenido del mensaje",
      subject: "asunto",
      userLang: "idioma del usuario",
      user: "usuario",
      admin: "administrador",
      staff: "registrador",
    },
    exportResults: {
      confidenceLevel: "intervalo de confianza",
      dateFrom: "fecha desde",
      dateTo: "fecha hasta",
      examineeAge: "edad",
      examineeData: "datos del examinado",
      examineeEdu: "educación",
      examineeName: "nombre y apellido",
      examineeFolder: "nombre de la carpeta",
      examineeId: "ID/identificador",
      examineeLab: "nombre del cliente",
      examineeSex: "sexo",
      exportDeletedFileSucceeded:
        "El archivo de exportación ha sido eliminado.",
      exportSucceeded:
        "La solicitud de exportación ha sido aceptada. Recibirá un correo electrónico sobre su finalización (éxito o error).",
      filesRefresh: "actualizar",
      filesToDownload: "Archivos para descargar:",
      folders: "carpetas",
      genres: "áreas de diagnóstico",
      noFiles: "No hay archivos para mostrar.",
      norm: "resultados normalizados",
      normStd: "resultados normalizados - intervalos de confianza",
      norms: "norma",
      protocol: "entrevista",
      psychLabs: "clientes",
      raw: "resultados brutos",
      rawStd: "resultados brutos - intervalos de confianza",
      resultsData: "resultados",
      tests: "pruebas",
    },
    statsExport: {
      exportSucceeded:
        "La solicitud de exportación de estadísticas ha sido aceptada. Recibirá un correo electrónico sobre su finalización (éxito o error).",
      deletedFileSucceeded: "El archivo de estadísticas ha sido eliminado.",
      filesToDownload: "Archivos de estadísticas para descargar:",
      noFiles: "No hay archivos de estadísticas para mostrar.",
      filesRefresh: "actualizar",
      rangeRequired: "Seleccione un rango de fechas (desde y hasta).",
    },
    extraFields: "Datos complementarios",
    fields: {
      additionalInfo: "Información adicional",
      address: "Calle y número",
      age: "Edad",
      appealAuthority: "Nombre de la institución",
      appealDeadline: "Fecha",
      birthDate: "Fecha de nacimiento",
      city: "Ciudad",
      country: "País",
      date: "Fecha",
      diffrentIdentificationNumber: "Otro identificador",
      directory: "Carpeta",
      documentDate: "Fecha de emisión",
      drivingLicense: "Categoría de permiso de conducir",
      drivingLicenseIssuer: "Autoridad emisora del permiso",
      education: "Educación",
      email: "Dirección de correo electrónico",
      examineeRegistryId: "Número de registro del sujeto",
      identificationNumber: "DNI/CURP",
      identityDocumentNumber: "Serie y número",
      identityDocumentType: "Documento de identidad",
      institutionName: "Nombre de la institución",
      interval: "Seleccionar intervalo de confianza",
      judgmentNumber: "Número de resolución",
      lang: "Idioma",
      languageReport: "Seleccionar idioma del informe",
      legalBasis: "Base legal del examen",
      months: "meses",
      name: "Nombre",
      nextExamination: "Fecha del próximo examen",
      phone: "Número de teléfono",
      postalCode: "Código postal",
      recipient: "Seleccionar destinatario",
      sex: "Sexo",
      standard: "Seleccionar norma",
      surname: "Apellidos",
      year: "Año",
      years: "Años",
      testName: "Nombre del test",
      credits: "Precio del cliente",
      creditsGlobal: "Precio",
      value: "Valor",
      values: "Valores",
    },
    options: {
      activities: {
        ADMIN_CHANGE_LAB_ID: "Administrador inició sesión en cuenta de cliente",
        ADMIN_LICENCE_ADDED: "Licencia de cuenta de cliente agregada",
        ADMIN_LICENCE_CHANGED: "Licencia de cuenta de cliente modificada",
        ADMIN_LICENCE_DELETED: "Licencia de cuenta de cliente eliminada",
        ADMIN_LOGGED_IN: "Administrador inició sesión",
        ADMIN_LOGGED_OUT: "Administrador cerró sesión",
        ADMIN_PSYCHOLOGICAL_LAB_ADDED: "Cuenta de cliente agregada",
        ADMIN_PSYCHOLOGICAL_LAB_CHANGED:
          "Datos de cuenta de cliente modificados",
        ADMIN_PSYCHOLOGICAL_LAB_DELETED: "Cuenta de cliente eliminada",
        ADMIN_USER_ADDED: "Usuario agregado a cuenta de cliente",
        ADMIN_USER_CHANGED: "Datos de usuario de cuenta de cliente modificados",
        ADMIN_USER_DELETED: "Usuario eliminado de cuenta de cliente",
        ALL: "todos",
        ALL_ITEMS: "Todas las actividades",
        APP_REGISTRATION: "Registro de aplicación",
        AUDIT_ERROR: "Error de registro de actividad",
        CONSOLE_PIN_VERIFICATION: "Verificación de PIN en consola de usuario",
        CONTRACT_DOWNLOADED: "Contrato descargado",
        DIRECTORY_CREATED: "Directorio creado",
        DIRECTORY_DELETED: "Directorio eliminado",
        DIRECTORY_NAME_CHANGED: "Nombre de directorio cambiado",
        EXAMINATION_ASSIGNED: "Examen asignado",
        EXAMINATION_DELETED: "Examen eliminado",
        EXAMINATION_PROTOCOLS_ZIP_DOWNLOADED:
          "Protocolos de examen ZIP descargados",
        EXAMINATION_PROTOCOL_DOWNLOADED: "Protocolo de examen descargado",
        EXAMINATION_REPORT_DOWNLOADED: "Documentos de informe descargados",
        EXAMINATION_STARTED: "Examen iniciado",
        EXAMINATION_TERMINATED: "Examen terminado",
        EXAMINEE_ADDED: "Sujeto agregado",
        EXAMINEE_DATA_CHANGE: "Datos del sujeto modificados",
        EXAMINEE_DELETED: "Datos del sujeto eliminados",
        EXAMINEE_MOVED_TO_DIFFERENT_DIRECTORY:
          "Datos del sujeto movidos a otro directorio",
        IMPORT_EXAMINEE: "Importar examinados",
        INTERVIEW_CHANGED: "Entrevista modificada",
        INTERVIEW_DOWNLOADED: "Entrevista descargada",
        PASSWORD_CHANGE: "Cambio de contraseña",
        PASSWORD_CHANGE_EXPIRED: "Cambio de contraseña después de expiración",
        PASSWORD_CHANGE_REQUEST: "Solicitud de cambio de contraseña",
        PIN_CHANGE: "Cambio de PIN",
        SAVE_AGREEMENTS:
          "Guardado de consentimientos para examen y procesamiento de datos",
        TEST_RESULT_SUBMITTED: "Resultados del examen enviados",
        TEST_SKIPPED: "Prueba omitida en consola",
        USER_LOGGED_IN: "Usuario inició sesión",
        USER_LOGGED_OUT: "Usuario cerró sesión",
        ADMIN_PRICELIST_CHANGED: "Modificación de lista de precios global",
        ADMIN_LAB_ANONYMIZED: "Anonimización de datos",
        EXPORT_RESULTS_GENERATED: "Exportación de resultados generada",
        EXPORT_FILE_DOWNLOADED:
          "Archivo de exportación de resultados descargado",
        EXPORT_FILE_DELETED: "Archivo de exportación de resultados eliminado",
        LAB_PARAMS_BULK_UPDATED: "Actualización de parámetros del laboratorio",
        EXAMINATION_DOCUMENT_DOWNLOADED: "Documento de examen descargado",
        EXAMINATION_DOCUMENT_CHANGED: "Documento de examen modificado",
        EXAMINATION_EXTENDED: "Examen ampliado con nuevas pruebas",
        IMPORT_EXAMINEE_AND_ASSIGNED_EXAMINATION:
          "Importación de examinados y asignación de exámenes",
        TEST_TYPE_CREDITS_UPDATED:
          "Modificación de lista de precios de tests para cliente",
        LICENSE_CREDITS_DEDUCTED:
          "Deducción de créditos al guardar resultados del test",
      },
      activitiesStatus: {
        ok: "correcto",
        server_error: "error del servidor",
        user_error: "error de usuario",
      },
      bool: {
        false: "No",
        true: "Sí",
      },
      country: {
        afghanistan: "Afghanistan",
        albania: "Albania",
        algeria: "Algeria",
        americanSamoa: "American Samoa",
        andorra: "Andorra",
        angola: "Angola",
        anguilla: "Anguilla",
        antarctica: "Antarctica",
        antiguaAndBarbuda: "Antigua and Barbuda",
        argentina: "Argentina",
        armenia: "Armenia",
        aruba: "Aruba",
        australia: "Australia",
        austria: "Austria",
        azerbaijan: "Azerbaijan",
        bahamas: "Bahamas",
        bahrain: "Bahrain",
        bangladesh: "Bangladesh",
        barbados: "Barbados",
        belarus: "Belarus",
        belgium: "Belgium",
        belize: "Belize",
        benin: "Benin",
        bermuda: "Bermuda",
        bhutan: "Bhutan",
        bolivia: "Bolivia",
        bonaireSintEustatiusAndSaba: "Bonaire, Sint Eustatius and Saba",
        bosniaAndHerzegovina: "Bosnia and Herzegovina",
        botswana: "Botswana",
        bouvetIsland: "Bouvet Island",
        brazil: "Brazil",
        britishIndianOceanTerritory: "British Indian Ocean Territory",
        bruneiDarussalam: "Brunei Darussalam",
        bulgaria: "Bulgaria",
        burkinaFaso: "Burkina Faso",
        burundi: "Burundi",
        cambodia: "Cambodia",
        cameroon: "Cameroon",
        canada: "Canada",
        capeVerde: "Cape Verde",
        caymanIslands: "Cayman Islands",
        centralAfricanRepublic: "Central African Republic",
        ceuta: "Ceuta",
        chad: "Chad",
        chile: "Chile",
        china: "China",
        christmasIsland: "Christmas Island",
        cocosIslands: "Cocos (Keeling) Islands",
        colombia: "Colombia",
        comoros: "Comoros",
        congo: "Congo (Rep.)",
        cookIslands: "Cook Islands",
        costaRica: "Costa Rica",
        coteDivoire: "Cote D’Ivoire",
        croatia: "Croatia",
        cuba: "Cuba",
        curacao: "Curaçao",
        cyprus: "Cyprus",
        czechRepublic: "Czechia",
        democraticRepublicOfTheCongo: "Congo (Dem. Rep.)",
        denmark: "Denmark",
        djibouti: "Djibouti",
        dominica: "Dominica",
        dominicanRepublic: "Dominican Republic",
        ecuador: "Ecuador",
        egypt: "Egypt",
        elSalvador: "El Salvador",
        equatorialGuinea: "Equatorial Guinea",
        eritrea: "Eritrea",
        estonia: "Estonia",
        ethiopia: "Ethiopia",
        falklandIslands: "Falkland Islands (Malvinas)",
        faroeIslands: "Faroe Islands",
        fiji: "Fiji",
        finland: "Finland",
        france: "France",
        frenchPolynesia: "French Polynesia",
        frenchSouthernTerritories: "French Southern Territories",
        gabon: "Gabon",
        gambia: "Gambia",
        georgia: "Georgia",
        germany: "Germany",
        ghana: "Ghana",
        gibraltar: "Gibraltar",
        greece: "Greece",
        greenland: "Greenland",
        grenada: "Grenada",
        guam: "Guam",
        guatemala: "Guatemala",
        guinea: "Guinea",
        guineaBssau: "Guinea-Bissau",
        guyana: "Guyana",
        haiti: "Haiti",
        heardAndMcdonaldIslands: "Heard and McDonald Islands",
        honduras: "Honduras",
        hongKong: "Hong Kong",
        hungary: "Hungary",
        iceland: "Iceland",
        india: "India",
        indonesia: "Indonesia",
        iran: "Iran, Islamic Republic of",
        iraq: "Iraq",
        ireland: "Ireland",
        israel: "Israel",
        italy: "Italy",
        jamaica: "Jamaica",
        japan: "Japan",
        jordan: "Jordan",
        kazakhstan: "Kazakhstan",
        kenya: "Kenya",
        kiribati: "Kiribati",
        koreaNorth: "Korea, Democratic People’s Republic of",
        kosovo: "Kosovo",
        kuwait: "Kuwait",
        kyrgyztan: "Kyrgyztan",
        lao: "Lao, People’s Democratic Republic of",
        latvia: "Latvia",
        lebanon: "Lebanon",
        lesotho: "Lesotho",
        liberia: "Liberia",
        libyan: "Libyan Arab Jamahiriya",
        liechtenstein: "Liechtenstein",
        lithuania: "Lithuania",
        luxembourg: "Luxembourg",
        macao: "Macao",
        madagascar: "Madagascar",
        malawi: "Malawi",
        malaysia: "Malaysia",
        maldives: "Maldives",
        mali: "Mali",
        malta: "Malta",
        marshallIslands: "Marshall Islands",
        mauritania: "Mauritania",
        mauritius: "Mauritius",
        mayotte: "Mayotte",
        melilla: "Melilla",
        mexico: "Mexico",
        micronesia: "Micronesia, Federal States of",
        moldova: "Moldova, Republic of",
        mongolia: "Mongolia",
        montenegro: "Montenegro",
        montserrat: "Montserrat",
        morocco: "Morocco",
        mozambique: "Mozambique",
        myanmar: "Myanmar",
        namibia: "Namibia",
        nauru: "Nauru",
        nepal: "Nepal",
        netherlands: "Netherlands",
        newCaledonia: "New Caledonia",
        newZealand: "New Zealand",
        nicaragua: "Nicaragua",
        niger: "Niger",
        nigeria: "Nigeria",
        niue: "Niue",
        norfolk: "Norfolk Island",
        northernMacedonia: "North Macedonia",
        northernMarianaIslands: "Northern Mariana Islands",
        norway: "Norway",
        oman: "Oman",
        pakistan: "Pakistan",
        palau: "Palau",
        palestinian: "Palestinian Territory, Occupied",
        panama: "Panama",
        papuaNewGuinea: "Papua New Guinea",
        paraguay: "Paraguay",
        peru: "Peru",
        philippines: "Philippines",
        pitcairn: "Pitcairn",
        poland: "Poland",
        portugal: "Portugal",
        qatar: "Qatar",
        romania: "Romania",
        russia: "Russian Federation",
        rwanda: "Rwanda",
        saintBarthelemy: "Saint Barthelemy",
        samoa: "Samoa",
        sanMarino: "San Marino",
        saoTomeAndPrincipe: "Sao Tome and Principe",
        saudiArabia: "Saudi Arabia",
        senegal: "Senegal",
        serbia: "Serbia",
        seychelles: "Seychelles",
        sierraLeone: "Sierra Leone",
        singapore: "Singapore",
        sintMaartenDutch: "Sint Maarten (Dutch part)",
        slovakia: "Slovakia",
        slovenia: "Slovenia",
        solomonIslands: "Solomon Islands",
        somalia: "Somalia",
        southAfrica: "South Africa",
        southGeorgiaAndSouthSandwichIslands:
          "South Georgia and South Sandwich Islands",
        southKorea: "Korea, Republic of",
        southSudan: "South Sudan",
        spain: "Spain",
        sriLanka: "Sri Lanka",
        stHelena: "St.Helena",
        stKittsandAndNevis: "St.Kittsand and Nevis",
        stLucia: "St.Lucia",
        stPierreAndMiquelon: "St Pierre and Miquelon",
        stVincentAndTheGrenadines: "St Vincent and the Grenadines",
        sudan: "Sudan",
        suriname: "Suriname",
        swaziland: "Swaziland",
        sweden: "Sweden",
        switzerland: "Switzerland",
        syrian: "Syrian Arab Republic",
        taiwan: "Taiwan, Provice of China",
        tajikistan: "Tajikistan",
        tanzania: "Tanzania, United Republic of.",
        thailand: "Thailand",
        timorLeste: "Timor Leste",
        togo: "Togo",
        tokelau: "Tokelau",
        tonga: "Tonga",
        trinidadAndTobago: "Trinidad and Tobago",
        tunisia: "Tunisia",
        turkey: "Turkey",
        turkmenistan: "Turkmenistan",
        turksAndCaicosIslands: "Turks and Caicos Islands",
        tuvalu: "Tuvalu",
        uganda: "Uganda",
        ukraine: "Ukraine",
        unitedArabEmirates: "United Arab Emirates",
        unitedKingdom: "United Kingdom",
        unitedKingdomNorthernIreland: "United Kingdom (Northern Ireland)",
        unitedStatesOfAmerica: "United States of America",
        uruguay: "Uruguay",
        usMinorOutlyingIslands: "U.S. Minor Outlying Islands",
        uzbekistan: "Uzbekistan",
        vanuatu: "Vanuatu",
        vatican: "Vatican City State",
        venezuela: "Venezuela",
        vietnam: "Vietnam",
        virginIslandsBritish: "Virgin Islands (British)",
        virginIslandsUSA: "Virgin Islands (USA)",
        wallisAndFutuna: "Wallis and Futuna Islands",
        westernSahara: "Western Sahara",
        yemen: "Yemen",
        zambia: "Zambia",
        zimbabwe: "Zimbabwe",
      },
      education: {
        basicIndustry: "Formación técnica básica",
        basicVocational: "Formación profesional básica",
        higher: "Superior",
        lowerSecondary: "Secundaria básica",
        primary: "Primaria",
        secondary: "Secundaria",
        secondaryIndustry: "Formación técnica media",
      },
      emailType: {
        break: "mantenimiento técnico",
        system: "información",
        update: "actualización",
      },
      exportResultConfidenceLevel: {
        item_85: "0.85",
        item_9: "0.9",
        item_95: "0.95",
        item_99: "0.99",
      },
      genres: {
        cognitive: "procesos cognitivos e intelectuales",
        personality: "personalidad",
        psychomotor: "psicomotricidad",
      },
      identityDocument: {
        idCard: "DNI",
        passport: "Pasaporte",
      },
      lang: {
        english: "Inglés",
        espaniol: "Español",
        mexico: "Español Mexicano",
        polish: "Polaco",
        russian: "Ruso",
        ukrain: "Ucraniano",
      },
      languagesDocumentation: {
        en: "inglés",
        pl: "polaco",
      },
      norms: {
        norm_1: "OPT_1.0.PL",
        norm_2: "OPT_1.0.UA",
        norm_3: "OPT_1.0.RU",
      },
      recipient: {
        examinee: "Sujeto",
        psychologist: "Psicólogo",
        specialist: "Especialista",
      },
      sex: {
        female: "Mujer",
        male: "Hombre",
      },
    },
    passwordFields: "Configuración de la contraseña",
    pwdFields: "Política de contraseñas",
    requiredFields: "Datos obligatorios",
    selectAll: "seleccionar todo",
    snackbar: {
      peselLength: "El número de identificación debe tener 11 dígitos",
      peselNumber: "El número de identificación solo puede contener números",
      required: "Debe completar todos los campos obligatorios.",
    },
  },
  HelpDocs: {
    contractFileName1: "/help-documents/pl-pl/kontrakt_psychologiczny_2024.pdf",
    contractFileName2:
      "/help-documents/pl-pl/kontrakt_psychologiczny_ru_2024.pdf",
    contractFileName3:
      "/help-documents/pl-pl/kontrakt_psychologiczny_ua_2024.pdf",
    contractFileName4:
      "/help-documents/pl-pl/polityka_ochrony_danych_osobowych_klauzula_informacyjna_2024.pdf",
    contractName1: "Contrato Psicológico 2024",
    contractName2: "Contrato Psicológico RU 2024",
    contractName3: "Contrato Psicológico UA 2024",
    contractName4:
      "Política de Protección de Datos Personales - Cláusula Informativa 2024",
    contractTitle: "Contratos",
    handbookFileName1:
      "/help-documents/pl-pl/charakterystyka_obszarow_diagnozy.pdf",
    handbookFileName2: "/help-documents/pl-pl/testy_psychomotoryczne.pdf",
    handbookFileName3: "/help-documents/pl-pl/testy_poznawcze.pdf",
    handbookFileName4: "/help-documents/pl-pl/testy_osobowosci.pdf",
    handbookFileName5: "/help-documents/pl-pl/katalog_testow_03_2024.pdf",
    handbookName1: "Características de Áreas de Diagnóstico",
    handbookName2: "Pruebas Psicomotoras",
    handbookName3: "Pruebas Cognitivas",
    handbookName4: "Pruebas de Personalidad",
    handbookName5: "Catálogo de Pruebas 03-2024",
    handbookTitle: "Manual y Catálogo de Pruebas",
    modulesFileName1: "/help-documents/pl-pl/sytuacja_zdrowotna.pdf",
    modulesFileName10:
      "/help-documents/pl-pl/psychologia_transportu_kierowanie pojazdami_mtd_IV.pdf",
    modulesFileName2: "/help-documents/pl-pl/sytuacja_spoleczna_i_rodzinna.pdf",
    modulesFileName3: "/help-documents/pl-pl/obserwacja.pdf",
    modulesFileName4: "/help-documents/pl-pl/detektywi_ochrona_bron_mtd_I.pdf",
    modulesFileName5: "/help-documents/pl-pl/koncesja_mtd_II.pdf",
    modulesFileName6: "/help-documents/pl-pl/medycyna_pracy_mtd_III.pdf",
    modulesFileName7: "/help-documents/pl-pl/kierowcy_sluzbowi_mtd_III.pdf",
    modulesFileName8: "/help-documents/pl-pl/praca_wysokosc_mtd_III.pdf",
    modulesFileName9: "/help-documents/pl-pl/wozki_widlowe_mtd_III.pdf",
    modulesName1: "Situación de Salud",
    modulesName10: "Psicología del Transporte Operación de Vehículos MTD IV",
    modulesName2: "Situación Social y Familiar",
    modulesName3: "Observación",
    modulesName4: "Detectives Protección Armas MTD I",
    modulesName5: "Licencia MTD II",
    modulesName6: "Medicina Ocupacional MTD III",
    modulesName7: "Conductores de Servicio MTD III",
    modulesName8: "Trabajo en Altura MTD III",
    modulesName9: "Montacargas MTD III",
    modulesTitle: "Módulos de Entrevista",
    policyName1:
      "Política de Protección de Datos Personales - Cláusula Informativa 2024",
    policyTitle1: "Política de protección de datos personales",
  },
  Helpdesk: {
    contact: "Contacto",
    text1: "",
    text2: "",
    text3: "",
    text4: "",
    documents: {
      header: "Documentos de ayuda",
      labels: {
        download: "Descargar",
        name: "Nombre del documento",
      },
    },
    header: "Ayuda",
    help: "Soporte remoto",
    mobile: "móvil",
    phoneNo: "tel.",
    subheader: "Mesa de ayuda",
    phoneNo1: "52 55 4933 7344",
    phoneNo2: "",
    phoneNo3: "",
    emailValue: "info.mexico@giuntipsy.com",
  },
  Interview: {
    header: "Entrevista",
    hours: "Horas",
    inputAdditionalInformation: "Ingrese información adicional",
    inputHoursOfWork: "Ingrese las horas trabajadas en las últimas 24 horas",
    months: "Meses",
    questions: {
      methodologies: {
        currentPsychophysicalState: {
          headers: {
            criticalEvents: "Eventos críticos",
            currentState: "Estado psicofísico actual",
          },
          questionExtendedTexts: {
            commonText: "Describa las circunstancias de este evento/situación",
          },
          questionTexts: {
            question1:
              "¿Ha consumido alcohol el sujeto en las últimas 48 horas?",
            question10: "Uso de asistencia de:",
            question10a: "a. psicólogo",
            question10b: "b. psiquiatra",
            question10c: "c. neurólogo",
            question11: "Certificado de discapacidad",
            question12: "Problemas debido al consumo de alcohol",
            question13: "Estancia en centro de desintoxicación",
            question14: "Uso de sustancias intoxicantes/psicoactivas/drogas",
            question15:
              "Sugerencias de un médico o alguien cercano para buscar tratamiento debido a nerviosismo, distracción o problemas de memoria u orientación",
            question2:
              "¿Ha trabajado profesionalmente el sujeto durante la última o penúltima noche?",
            question3: "Número de horas trabajadas en las últimas 24 horas",
            question4: "Lesión en la cabeza que requirió atención médica",
            question5: "Pérdida de consciencia",
            question6: "Estancia hospitalaria",
            question7:
              "¿Ha habido o hay actualmente tratamiento por/ha habido alguna vez diagnóstico de las siguientes enfermedades:",
            question7a:
              "a. enfermedades del sistema digestivo (úlcera gástrica o duodenal, disfunción intestinal, etc.)",
            question7b:
              "b. enfermedades del corazón y sistema circulatorio (enfermedad coronaria, presión arterial alta)",
            question7c:
              "c. trastornos auditivos o visuales (excluyendo gafas correctivas)",
            question7d: "d. diabetes",
            question7e: "e. epilepsia",
            question7f:
              "f. enfermedades mentales (depresión, neurosis, tratamiento psiquiátrico (preguntar sobre tratamiento psiquiátrico de un familiar cercano)",
            question8:
              "Uso regular de medicamentos (preguntar si conoce los efectos secundarios y sobre otros medicamentos que afecten las funciones mentales)",
            question9: "Problemas de sueño",
          },
        },
        detectivesSecurityGuardsAndWeaponPermits: {
          questionAnswers: {
            question1a:
              "para fines profesionales (detective, guardia de seguridad)",
            question1b: "para fines de caza",
            question1c: "para fines deportivos",
            question1d: "para uso personal",
            question1e: "para fines museísticos, conmemorativos, científicos",
            question1f: "otros",
          },
          questionTexts: {
            question1: "Propósitos principales del uso de armas:",
            question1g: "¿Cuáles?",
            question2:
              "¿Ha habido alguna vez uso de armas u otros medios de coerción directa?",
            question3:
              "¿Con qué frecuencia se han usado armas en los últimos 5 años?",
          },
        },
        drivingVehicles: {
          headers: {
            drivingCharacteristics: "Características de las rutas",
          },
          questionAnswers: {
            question13a: "como causante/co-causante",
            question13b: "como víctima",
            question13c: "no aplicable",
            question14a: "como causante/co-causante",
            question14b: "como víctima",
            question14c: "no aplicable",
            question15a: "transporte de materiales peligrosos",
            question15b: "transporte de pasajeros",
            question15c: "instructor de conducción",
            question15d: "examinador de conducción",
            question15e: "ninguno",
            question3a: "menos de 3.000 km anuales",
            question3b: "entre 3.000 – 15.000 km anuales",
            question3c: "entre 15.000 - 70.000 km anuales",
            question3d: "más de 70.000 km anuales",
            question3e: "difícil de decir",
            question4a: "menos de 5 horas semanales",
            question4b: "entre 5 - 15 horas semanales",
            question4c: "entre 15 - 40 horas semanales",
            question4d: "más de 40 horas semanales",
            question4e: "difícil de decir",
            question5a: "conduzco principalmente rutas cortas",
            question5b: "conduzco principalmente rutas largas",
            question5c: "conduzco tanto rutas largas como cortas",
            question6a: "suelo conducir rutas fijas",
            question6b: "suelo conducir rutas diferentes",
            question7a: "conduzco más frecuentemente de noche",
            question7b: "suelo conducir durante el día",
            question7c: "conduzco tanto de día como de noche",
            question8a: "conduzco principalmente solo sin relevo",
            question8b: "conduzco más frecuentemente con relevo",
            question9a: "conduzco principalmente en ciudad",
            question9b: "conduzco principalmente fuera de la ciudad",
          },
          questionTexts: {
            question1: "Experiencia general de conducción",
            question10: "Suspensión o revocación del permiso de conducir",
            question11: "Declaración de incapacidad para conducir",
            question12: "Sanción por infracción o delito de tráfico",
            question13: "Participación como conductor en accidente de tráfico",
            question14: "Participación como conductor en colisión de tráfico",
            question15: "Calificaciones y licencias adicionales",
            question2: "Experiencia como conductor profesional",
            question3: "Kilometraje anual",
            question4: "Horas dedicadas a la conducción",
            question5: "Longitud de rutas",
            question6: "Variedad de rutas",
            question7: "Horario",
            question8: "Conductor de relevo",
            question9: "Área",
          },
        },
        licensedActivity: {
          questionTexts: {
            question1:
              "Experiencia laboral total en establecimiento dedicado a actividades con licencia",
            question2: "Cargo/funciones realizadas",
            question3:
              "Experiencia laboral en el cargo actual en establecimiento dedicado a actividades con licencia",
            question4a: "Participación en accidente laboral",
            question4b:
              "¿Cuáles fueron las causas, consecuencias del accidente - hubo daños a la propiedad, salud?",
          },
        },
        observation: {
          questionAnswers: {
            question1a:
              "Establece muy buen contacto con el entrevistador; mantiene contacto visual; se comporta con confianza y naturalidad, no se deja desestabilizar ni impacientar, se comporta de manera espontánea y natural.",
            question1b:
              "Establece contacto con el entrevistador; mantiene contacto visual; se comporta con naturalidad, aunque son visibles signos de cierto nerviosismo.",
            question1c:
              "Se comporta de manera distante, evita el contacto visual; se comporta de manera poco natural, pequeños estímulos causan pérdida de equilibrio, son visibles claros signos de nerviosismo e impaciencia.",
            question2a:
              "Formula declaraciones usando un lenguaje correcto, construye oraciones claras y legibles, mantiene una estructura lógica del discurso, utiliza un vocabulario rico.",
            question2b:
              "Formula declaraciones correctamente, generalmente mantiene su estructura lógica; vocabulario promedio pero correcto.",
            question2c:
              "Formula declaraciones cortas y superficiales, a menudo incoherentes o poco claras; usa frases y formulaciones incorrectas; las oraciones son muy simples, vocabulario muy pobre, ocurren errores gramaticales.",
            question3a:
              "Estado de ánimo observable muy alegre y optimista; satisfacción consigo mismo y su situación vital.",
            question3b:
              "Estado de ánimo observable moderado, actitud bastante positiva y perspectiva generalmente optimista del futuro.",
            question3c:
              "Reacciones emocionales observables desproporcionadamente fuertes, clara tendencia hacia una percepción pesimista del mundo; muestra insatisfacción.",
            question4a:
              "Durante el examen controla adecuadamente el comportamiento y las emociones, se adapta adecuadamente a las circunstancias emergentes.",
            question4b:
              "Durante el examen generalmente controla el comportamiento y las emociones; la mayoría de las veces responde adecuadamente a las circunstancias emergentes.",
            question4c:
              "Durante el examen dificultades observables con el control del comportamiento y las emociones; aparecen comportamientos o emociones inadecuados.",
          },
          questionTexts: {
            question1: "Contacto con el entrevistador",
            question2: "Lenguaje y retórica",
            question3: "Estado de ánimo y actitud",
            question4: "Compostura y control del comportamiento y emociones",
          },
        },
        occupationalMedicine: {
          headers: {
            companyCarDrivers: "Conductores de vehículos de empresa",
            forkliftOperators: "Operadores de carretilla elevadora",
            minersAndMinerLifeguards: "Mineros y rescatistas mineros",
            trainDriver: "Conductores de tren",
            workCourseInformation: "Historial de carrera profesional",
            workInformation: "Información laboral profesional",
            workingAtHeights: "Trabajo en altura",
          },
          questionAnswers: {
            question13a: "menos de 3.000 km anuales",
            question13b: "entre 3.000 – 15.000 km anuales",
            question13c: "entre 15.000 - 70.000 km anuales",
            question13d: "más de 70.000 km anuales",
            question13e: "difícil de decir",
            question14a: "menos de 5 horas semanales",
            question14b: "entre 5 - 15 horas semanales",
            question14c: "entre 15 - 40 horas semanales",
            question14d: "más de 40 horas semanales",
            question14e: "difícil de decir",
            question18a: "como causante/co-causante",
            question18b: "como víctima",
            question18c: "no aplicable",
            question19a: "como causante/co-causante",
            question19b: "como víctima",
            question19c: "no aplicable",
            question5a: "Trabajo monótono",
            question5b: "Constante alto flujo de información",
            question5c: "Alto nivel de ruido",
            question5d:
              "Trabajo con alta carga psicológica (responsabilidad y toma de decisiones)",
            question5e: "Radiación ionizante",
            question5f: "Factores químicos",
            question5g: "Otros",
          },
          questionTexts: {
            question1: "Profesión formada",
            question10: "Sujeto involucrado en accidente laboral",
            question10a:
              "¿Cuándo? ¿Cuáles fueron las consecuencias para la salud?",
            question11: "Discapacidad determinada",
            question11a: "¿Por qué motivo? ¿Desde cuándo? ¿Hasta cuándo?",
            question12: "Experiencia general de conducción",
            question13: "Kilometraje anual",
            question14: "Horas dedicadas a la conducción",
            question15: "Declaración de incapacidad para conducir",
            question16: "Suspensión o revocación del permiso de conducir",
            question17: "Sanción por infracción o delito de tráfico",
            question18: "Participación como conductor en accidente de tráfico",
            question19: "Participación como conductor en colisión de tráfico",
            question2: "Profesión actual",
            question20: "Cualificaciones para trabajo en altura",
            question21:
              "Realización de trabajos en altura (si es afirmativo, preguntar cuántos metros sobre el suelo)",
            question22:
              "Sensación subjetiva de miedo durante la permanencia en altura",
            question23: "Accidente durante el trabajo en altura",
            question23a: "¿Hubo daños a la propiedad o a la salud?",
            question24: "Cualificaciones para operar carretilla elevadora",
            question25:
              "Realización de trabajos relacionados con la operación y conducción de carretilla elevadora",
            question26:
              "Accidente durante la operación o conducción de carretilla elevadora",
            question26a: "¿Hubo daños a la propiedad o a la salud?",
            question3: "Lugar de trabajo / escuela",
            question4: "Cargo / funciones realizadas",
            question5:
              "Factores nocivos/molestos permanentes en el lugar de trabajo",
            question5f: "¿Cuáles?",
            question5g: "¿Cuáles?",
            question6: "Experiencia laboral total",
            question7: "Experiencia en el cargo actual",
            question8: "Enfermedad profesional diagnosticada",
            question8a: "¿Cuándo? ¿Por qué motivo?",
            question9: "Beneficios por discapacidad concedidos",
            question9a: "¿Por qué motivo? ¿Desde cuándo? ¿Hasta cuándo?",
          },
        },
        socialAndFamilySituation: {
          questionTexts: {
            question1:
              "Conflicto o problema grave relacionado con el trabajo (p.ej., accidente laboral, amonestación, tribunal laboral, despido disciplinario, acoso laboral)",
            question2:
              "Problemas durante la educación (p.ej., repetición de curso, expulsión de la escuela, suspensión de derechos estudiantiles)",
            question3:
              "Conflicto familiar grave o problemas en situaciones privadas (p.ej., casos judiciales, participación en peleas, se puede preguntar sobre estado civil, hijos)",
            question4:
              "Situación de peligro directo para la vida (p.ej., incendio, inundación y otros desastres)",
            question5:
              "Experiencia de violencia física contra uno mismo (p.ej., agresión, robo, golpes)",
            question6:
              "Participación en organizaciones sociales (p.ej., voluntariado)",
            question7:
              "Antecedentes penales (p.ej., recibir multas, sentencia judicial)",
          },
        },
      },
      questionAnswers: {
        no: "no",
        yes: "sí",
      },
      questionTexts: {
        describeTheCircumStancesOfUsage: "Describa las circunstancias de uso",
        forHowLong: "¿Hasta cuándo?",
        sinceWhen: "¿Desde cuándo?",
        whatAreTheConsequences: "¿Cuáles fueron las consecuencias de salud?",
        when: "¿Cuándo?",
        why: "¿Por qué motivo?",
      },
    },
    tabs: {
      currentPsychophysicalState: "Situación de salud",
      drivingVehicles: "Conducción de vehículos",
      licensedActivities: "Actividades con licencia",
      observation: "Observación",
      occupationalMedicine: "Medicina laboral",
      securityAndDetectives: "Servicios de seguridad y detective",
      socialAndFamilySituation: "Situación social y familiar",
    },
    years: "Años",
  },
  Language: {
    pl: "Polaco",
    ru: "Ruso",
    uk: "Ucraniano",
  },
  Login: {
    Access_denied: "Acceso denegado",
    Captcha_error:
      "Error al completar el captcha. Por favor, inténtelo de nuevo.",
    Instance_configured_incorrectly:
      "Error de configuración del sistema. Comunique el problema al soporte técnico.",
    Laboratory_is_inactive_or_deleted: "Cuenta de cliente inactiva",
    Laboratory_account_has_expired:
      "Inicio de sesión fallido — la cuenta ha expirado.",
    No_recaptcha_token_provided:
      "Error de recaptcha. Comunique el problema al soporte técnico.",
    User_account_has_been_deleted: "User account is inactive",
    User_account_is_not_active: "La cuenta de usuario ha sido eliminada",
    Validation_failed: "Correo electrónico o contraseña incorrectos.",
    adminHeader: "PANEL DE ADMINISTRACIÓN",
    error: "Correo electrónico o contraseña incorrectos.",
    header: "INICIAR SESIÓN",
    reset: "Restablecer contraseña",
    warning: "El BLOQ MAYÚS está activado",
  },
  Onboarding: {
    errorText:
      "Se produjo un error al establecer la contraseña, por favor inténtelo de nuevo más tarde.",
    setNewPasswordInfo:
      "Introduzca la contraseña que utilizará para iniciar sesión en el sistema.",
    setPasswordFormLabel: "Establecer contraseña",
    setPinFormLabel: "Establezca su PIN",
    setPinInfo:
      "Introduzca el PIN que utilizará para iniciar sesión en la consola del psicólogo.",
    success:
      "Su contraseña y PIN han sido guardados. Ahora puede iniciar sesión en la aplicación por primera vez utilizando su dirección de correo electrónico y contraseña.",
    successTitle: "Contraseña y PIN establecidos",
  },
  Pagination: {
    outOf: "de",
  },
  PasswordExpired: {
    form: {
      header: "Establecer nueva contraseña",
      text: "Introduzca la contraseña que utilizará para iniciar sesión en el sistema.",
    },
    popup: {
      header: "La contraseña ha caducado",
      text: "Será redirigido al proceso de restablecimiento de contraseña para establecer una nueva.",
    },
    success: {
      header: "Contraseña guardada",
      text: "Su contraseña ha sido cambiada. Ahora puede acceder a la aplicación.",
    },
  },
  PsychologicalTests: {
    cognitive: "Pruebas cognitivas",
    personality: "Pruebas de personalidad",
    psychomotor: "Pruebas psicomotoras",
  },
  ResetPassword: {
    errorText:
      "Se produjo un error al restablecer la contraseña, por favor inténtelo de nuevo más tarde.",
    formHeader: "Restablecer Contraseña",
    resetEmailSentPt1: "Se ha enviado un correo electrónico a: ",
    resetEmailSentPt2:
      " con las instrucciones para el proceso de restablecimiento de contraseña.",
    resetInfo:
      "Introduzca la dirección de correo electrónico de su cuenta para recibir un enlace de restablecimiento de contraseña.",
    setNewPassword: "Establecer nueva contraseña",
    setNewPasswordInfo:
      "Introduzca la contraseña que utilizará para iniciar sesión en el sistema.",
    success:
      "Su contraseña ha sido cambiada. Ahora puede iniciar sesión en la aplicación utilizando su dirección de correo electrónico y nueva contraseña.",
    successTitle: "Contraseña Guardada",
  },
  SearchEngine: {
    enterFilter:
      "Puedes buscar por nombre, apellido, número de DNI/Identificador\n o por fecha de asignación del examen \n en formato DD-MM-AAAA.",
    header: "Buscar examinados",
    noResults: "No hay resultados de búsqueda",
    noResultsForFilter:
      "No se encontraron examinados que cumplan con los requisitos introducidos.",
    placeholderDesktop:
      "Nombre, apellido, DNI/Identificador, fecha de asignación del examen (DD-MM-AAAA)",
    placeholderMobile: "Buscar",
    searchForExaminees: "Buscar examinados",
  },
  RegistryResults: {
    header: "Registro de examinados",
    headerMobile: "Registro de examinados",
    clientAccounts: "Cuentas de clientes",
    clientAccountsRequired:
      "Se debe seleccionar al menos una cuenta de cliente.",
    foldersRequired: "Selecciona al menos una carpeta.",
    legalBasisRequired: "Selecciona al menos una base legal del examen.",
    folders: "Carpetas",
    dateFrom: "Fecha desde",
    dateTo: "Fecha hasta",
    legalBasis: "Bases legales",
    generateButton: "Generar registro",
    filesToDownload: "Archivos para descargar",
    filesRefresh: "Actualizar lista de archivos",
    noFiles: "No hay archivos generados.",
    exportSucceeded:
      "La solicitud de generación del registro ha sido aceptada. Recibirá un correo electrónico sobre su finalización (éxito o error).",
    dateRangeError:
      'La fecha "desde" no puede ser posterior a la fecha "hasta".',
    exportDeletedFileSucceeded: "El archivo de registro ha sido eliminado.",
    popups: {
      delete: {
        confirmationHeader:
          "¿Estás seguro de que quieres eliminar el archivo de registro?",
        confirmationText:
          "Una vez eliminado, el archivo de registro no se puede restaurar.",
        confirmationCheckboxLabel: "Sí, deseo eliminar el archivo de registro",
      },
    },
  },
  PriceList: {
    header: "Lista de precios",
    headerMobile: "Lista de precios",
    testName: "Nombre de la prueba",
    credits: "Créditos",
  },
  SendEmail: {
    header: "Envío de notificaciones",
    headerMobile: "Envío de notificaciones",
  },
  Snackbars: {
    createExaminationSuccess: "Examen asignado correctamente",
    extendExaminationSuccess: "Examen extendido correctamente con nuevos tests",
    recalculateExaminationSuccess: "Resultados del examen recalculados",
    createExamineeSuccess: "Examinado añadido correctamente",
    createMultiExaminationSuccess:
      "Exámenes importados y asignados correctamente",
    createPsychLabSuccess: "Cuenta de cliente añadida correctamente",
    createPsychLicSuccess: "Licencia añadida correctamente",
    createPsychUserSuccess: "Usuario añadido correctamente",
    deleteExaminationSuccess: "Examen eliminado correctamente",
    anonymizePsychLabSuccess: "Datos del cliente anonimizados correctamente",
    anonymizePsychLabEmptySuccess:
      "No hay exámenes para anonimizar. Los datos del cliente han sido limpiados.",
    deletePsychLabSuccess: "Cuenta de cliente eliminada correctamente",
    editExamineeSuccess: "Examinado editado correctamente",
    editPsychLabSuccess: "Cuenta de cliente editada correctamente",
    editPsychLicSuccess: "Licencia editada correctamente",
    editPsychUserSuccess: "Usuario editado correctamente",
    transferUserDataSuccess: "Exámenes y carpetas transferidos correctamente",
    failedRequest: "Se ha producido un problema: ",
    movingExamineesSuccess: "Trasladado a otra carpeta correctamente",
    examineesListGeneratedSuccess: "Lista de examinados generada correctamente",
    examineesListGeneratedError: "Error al generar la lista de examinados",
    deleteExamineeSuccess: "Examinado eliminado correctamente",
    bulkDeleteExamineesSuccess: "Examinados eliminados correctamente: %{deleted}",
    bulkDeleteExamineesPartial:
      "Examinados eliminados: %{deleted}. Omitidos (tienen exámenes): %{skipped}",
    passwordChangeSuccess: "Cambio de contraseña exitoso",
    pinChangeSuccess: "Cambio de PIN exitoso",
    success: "Acción exitosa",
    unrecognizedError: "Error no reconocido, compruebe la conexión a Internet",
    editTestCreditSuccess: "Precio del test en créditos guardado correctamente",
    editTestCreditError:
      "No se ha podido guardar el precio del test en créditos",
    unblockedExamSuccess: "Exámenes del cliente desbloqueados correctamente",
  },
  LandscapePrompt: {
    title: "Gira tu dispositivo a horizontal",
    description:
      "La edición de documentación no está disponible en modo vertical. Para continuar, gira tu dispositivo a horizontal.",
  },
  TwoFactor: {
    backupCode: "Código de respaldo",
    backupCodes: "Códigos de respaldo",
    backupCodesInfo:
      "Guarda estos códigos de respaldo en un lugar seguro. Puedes usarlos para acceder a tu cuenta si pierdes tu dispositivo de autenticación.",
    confirmDisable:
      "Ingresa tu contraseña para desactivar la autenticación de dos factores",
    disableError: "Error al desactivar la autenticación de dos factores",
    disableSuccess:
      "La autenticación de dos factores se ha desactivado correctamente",
    disableTitle: "Desactivar autenticación de dos factores",
    enterBackupCode: "Ingresa el código de respaldo",
    enterCode:
      "Ingresa el código de verificación de tu aplicación de autenticación",
    scanQRCode: "Escanea este código QR con tu aplicación de autenticación",
    secretKey: "Clave secreta",
    setupError: "Error al configurar la autenticación de dos factores",
    setupSuccess:
      "La autenticación de dos factores se ha configurado correctamente",
    setupTitle: "Configurar autenticación de dos factores",
    useAuthenticator: "Usar autenticador",
    useBackupCode: "Usar código de respaldo",
    verificationCode: "Código de verificación",
    verificationError: "Código de verificación inválido",
    verifyTitle: "Verificar autenticación de dos factores",
  },
  UserSettings: {
    access: "Acceso",
    facilityInfo: "Información del centro",
    header: "Configuración de la cuenta",
    headerChangePassword: "Cambiar contraseña",
    headerChangePin: "Cambiar PIN",
    headerMobile: "Configuración",
    helpdeskMsgLab:
      "Para cambiar la información del centro o usuario, llama al:",
    helpdeskMsgUser:
      "Para cambiar la información del centro o usuario, llama al:",
    infoSubHeaders: {
      address: "Dirección",
      cin: "Número de registro",
      dateExpire: "Fecha de caducidad de la cuenta",
      email: "Correo electrónico",
      firstName: "Nombre",
      id: "ID del cliente",
      labName: "Nombre",
      lastName: "Apellidos",
      licenseNumber: "Número de licencia",
      assignedClientAccount: "Cuenta de cliente a la que estás asignado",
      tin: "NIF",
    },
    license: {
      license: "Licencia",
      dateLicExpire: "Fecha de caducidad de la licencia: ",
      remainingCredits: "Créditos pendientes de utilizar: ",
      allCredits: "Créditos adquiridos: ",
      lockedCredits: "Créditos bloqueados en exámenes: ",
      freeCredits: "Créditos disponibles: ",
    },
    passwordChange: "Cambio de contraseña",
    passwordExpiry: "Tu contraseña caduca: ",
    pinChange: "Cambio de PIN",
    pinChangeMobile: "Cambio de PIN",
    pinInfo:
      "Introduce el PIN que utilizarás para iniciar sesión en la consola del psicólogo.",
    setNewPin: "Establecer nuevo PIN",
    userInfo: "Información del usuario",
  },
  CsvHeaders: {
    firstName: "Nombre",
    lastName: "Apellido",
    identificationNumber: "Identificador",
    directoryName: "Nombre de carpeta",
  },
  CsvFileName: {
    examineesList: "lista-examinados",
  },
  SystemParams: {
    showBatteriesDesc:
      "bandera que indica si mostrar baterías al invitar a examen, valores: 0, 1",
    t2sTestsDesc:
      "lista de pruebas seleccionadas por defecto al elegir metodología T2S, valor de ejemplo: SIRT,CHORT,HECOR....",
    t2aTestsDesc:
      "lista de pruebas seleccionadas por defecto al elegir metodología T2A, valor de ejemplo: SIRT,CHORT,HECOR....",
    t2wTestsDesc:
      "lista de pruebas seleccionadas por defecto al elegir metodología T2W, valor de ejemplo: SIRT,CHORT,HECOR....",
    t2dTestsDesc:
      "lista de pruebas seleccionadas por defecto al elegir metodología T2D, valor de ejemplo: SIRT,CHORT,HECOR....",
    selectTestsDesc:
      "lista de pruebas seleccionadas por defecto al invitar sin base legal, valor de ejemplo: SIRT,CHORT,HECOR....",
    batteriesListDesc:
      "lista de baterías visible al invitar a examen si el parámetro SHOW_BATTERIES está establecido en 1, valor de ejemplo: TEST2DRIVE,TEST2SPORT...",
    showRecalculateExamDesc:
      "Si mostrar la acción de recalcular el examen en la lista de exámenes para administradores del laboratorio (is_admin), valores: 0, 1",
    showExtendedExamDesc:
      "Si permitir ampliar exámenes cerrados con nuevos tests, valores: 0, 1",
    showExamineeRegistryDesc:
      "Registro de examinados disponible desde el panel del psicólogo – si mostrar el módulo de registro, valores: 0, 1",
    showImportExamineeDesc:
      "Importación de examinados disponible desde el panel del psicólogo, valores: 0, 1",
    allowExportResultDesc:
      "Exportación de resultados disponible desde el panel del psicólogo, valores: 0, 1",
    passwordExpiryDaysDesc:
      "Número de días de validez de la contraseña del usuario (p. ej. 30, 60, 90)",
    allowDelExaminessDesc:
      "Si se permite eliminar varios examinados a la vez, valores: 0, 1",
    allowDelExamineeWithExamDesc:
      "Si se permite eliminar un examinado junto con sus exámenes, valores: 0, 1",
    batteries: "Batería",
  },
};